import { Service, ServiceTaggingDetail, PAGEACTIVITY, OfferTypes } from './../constants/actionType'
//import * as persaction from './../action/personalisation'
import { catchJSException, logOtherInfo, detailsInfo } from './logService'
import { store } from './../index';
import { getPDCforSC } from './apiService'
import { InHomeUtils } from './../util/inhomeUtils'

export const getDTMInit = (pageInfo, stateInfo, data = {}) => {
    if (pageInfo === "checkAvaillqInit") {
        tempSCData.isDTMCallCompleted = false;
    }

    let device = "eordering";
    let dtmtmpurl = window.location.href.toLowerCase();

    if (dtmtmpurl.indexOf('/clu') !== -1) {
        device = 1 === /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()) ? "residential - mobile" : /Tablet|iPad/i.test(navigator.userAgent.toLowerCase()) ? "residential tablet" : "residential";
    }
    else if (dtmtmpurl.indexOf('/urc') !== -1 || dtmtmpurl.indexOf('/change') !== -1) {
        device = 1 === /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()) ? "urc mobile" : /Tablet|iPad/i.test(navigator.userAgent.toLowerCase()) ? "urc tablet" : "urc desktop";
    }
    else {
        if ((/android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()))) {
            device = (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.appInfo) && InHomeUtils.isNotNull(stateInfo.appInfo.flowType) && stateInfo.appInfo.flowType === "SUPP") ? "supp - mobile" : "mobile";
        }
        else if (/Tablet|iPad/i.test(navigator.userAgent.toLowerCase())) {
            device = (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.appInfo) && InHomeUtils.isNotNull(stateInfo.appInfo.flowType) && stateInfo.appInfo.flowType === "SUPP") ? "supp - tablet" : "eordering tablet";
        }
        else {
            device = (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.appInfo) && InHomeUtils.isNotNull(stateInfo.appInfo.flowType) && stateInfo.appInfo.flowType === "SUPP") ? "supp - desktop" : "eordering";
        }
    }

    let flowName = dtmtmpurl.indexOf("/clu") !== -1 ? "" : "prospect accord";
    let pagetype = -1 !== dtmtmpurl.indexOf("/clu") ? "learn" : (-1 !== dtmtmpurl.indexOf("/inhome") || -1 !== dtmtmpurl.indexOf("/local")) ? "order" : "learn";
    let pfxID = (-1 !== dtmtmpurl.indexOf("/urc") || -1 !== dtmtmpurl.indexOf("/change")) ? "urc" : (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.appInfo) && InHomeUtils.isNotNull(stateInfo.appInfo.flowType) && stateInfo.appInfo.flowType === "SUPP") ? "whn" : "res";
    let lineOfBusiness = (-1 !== dtmtmpurl.indexOf("/urc") || (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.appInfo) && InHomeUtils.isNotNull(stateInfo.appInfo.flowType) && (stateInfo.appInfo.flowType === "SUPP" || stateInfo.appInfo.flowType === "AF"))) ? "myverizon" : "residential";
    let adobesuite = -1 !== dtmtmpurl.indexOf("/clu") ? (document.domain.indexOf("www.verizon.com") !== -1 ? "verizontelecomglobal,verizontelecomres" : "verizontelecomglobaldev,verizontelecomresdev") : (document.domain.indexOf("www.verizon.com") !== -1 ? "verizontelecomglobal,verizontelecomres" : "verizontelecomglobaldev,verizontelecomresdev");

    if (dtmtmpurl.indexOf("/urc") !== -1) {
        adobesuite = document.domain.indexOf("www.verizon.com") !== -1 ? "verizontelecomglobal" : "verizontelecomglobaldev";
    }

    let initData = scDataDetails[pageInfo];

    let scUserProfileData = {
        "personalizationXP1String": "", "profileID": "", "loginStatus": "", "customerType": "",
        "productInterestXP1": "", "shoppingStageXp1": "", "cartContentsXp1": "", "existingProductsXp1": "",
        "leadOffer": "", "closestCableXp1": "", "profileIDXp1": "", "verizonUID": "", "existingTotalRecurring": "", "offerTypeXp1": "",
        "sessionIDs": "", "productQualXp1": "", "MKSegmentCode": "", "newRepeatXp1": "",
        "creditCheck": "", "depositAsked": "", "depositPaid": "", "prepaid": "N", "customerCategory": "", "pdcString": "", "channelSession": ""
    }

    let scExistingProductData = [];
    let sflowName = getFlowName(stateInfo, pageInfo, flowName);

    flowName = sflowName;

    //Setting Page Data -- Starts       

    if (InHomeUtils.isNotNull(stateInfo)) {
        if (InHomeUtils.isNotNull(stateInfo.appInfo) && stateInfo.appInfo.flowType === "SUPP") {
            pagetype = "supp order";
            scUserProfileData.loginStatus = "res logged in";
            tempSCData.isSUPPflow = true;
        }
        if (InHomeUtils.isNotNull(stateInfo.appInfo) && stateInfo.appInfo.flowType === "15G") {
            initData = Object.assign({}, initData, {                
                events: initData.events + ",scAdd"                
            })
        }

        if (InHomeUtils.isNotNull(stateInfo.appInfo) && stateInfo.appInfo.flowType === "AF") {
            scUserProfileData.loginStatus = "logged in";
        }

        if (pageInfo === "buildFiosInit" && InHomeUtils.isNotNull(stateInfo.lqInfo)
            && InHomeUtils.isNotNull(stateInfo.lqInfo.doFlowDetails)
            && stateInfo.lqInfo.doFlowDetails.isDoFlow && !stateInfo.isSmartCartFlow) {
            initData = Object.assign({}, initData, {
                offerid: stateInfo.lqInfo.doFlowDetails.DOIDValue,
                pageName: "do accord",
                events: initData.events + ",scAdd",
                detailPageName: "do accord"
            })
        }

        if ((pageInfo === "buildFiosInit" || pageInfo === "buildFiosMoves")
            && InHomeUtils.isNotNull(stateInfo.isGPONMOCHAEligible) && stateInfo.isGPONMOCHAEligible) {
            initData = Object.assign({}, initData, {
                events: initData.events.indexOf("scAdd") === -1 ? initData.events + ",scAdd" : initData.events,
                detailPageName: initData.detailPageName + " - si gpon-mocha eligible"
            })
        }

        if (pageInfo === "checkAvaillqInit" && InHomeUtils.isNotNull(stateInfo.lqInfo)
            && InHomeUtils.isNotNull(stateInfo.lqInfo.doFlowDetails)
            && stateInfo.lqInfo.doFlowDetails.isDoFlow) {
            initData = Object.assign({}, initData, {
                offerid: stateInfo.lqInfo.doFlowDetails.DOIDValue
            })
        }

        if (pageInfo === "lboInit") {
            initData = Object.assign({}, initData, {
                detailPageName: "lbo " + (InHomeUtils.isNotNull(stateInfo.lboInfo) ? stateInfo.lboInfo : "")
            })
        }

        if (pageInfo === "careFlowPageInit") {
            let tmpdetailpn = "affinity eligibility info";
            let tmppn = initData.pageName;
            if (InHomeUtils.isNotNull(stateInfo.careFlowTypeInfo) && stateInfo.careFlowTypeInfo === "employee") {
                tmpdetailpn = "ultimate employees eligibility info";
            }
            else if (InHomeUtils.isNotNull(stateInfo.carePathInfo) && stateInfo.carePathInfo === "?enterpriseid") {
                tmpdetailpn = "ultimate employees eligibility info - employee id";
            }
            else if (InHomeUtils.isNotNull(stateInfo.careFlowTypeInfo) && stateInfo.careFlowTypeInfo === "affinity") {
                tmppn = "affinity eligibility info no work email";
                tmpdetailpn = "connections eligibility info no work email";
            }
            else if (InHomeUtils.isNotNull(stateInfo.carePathInfo) && stateInfo.carePathInfo === "?uploadproof") {
                tmppn = "affinity eligibility info no work email";
                tmpdetailpn = "connections eligibility info no work email - documentation";
            }
            else if (InHomeUtils.isNotNull(stateInfo.carePathInfo)
                && (stateInfo.carePathInfo === "?confirmation" || stateInfo.carePathInfo === "?confirmation&fromflow=uploadproof" || stateInfo.carePathInfo === "?confirmation&fromflow=retiree")) {
                if (stateInfo.carePathInfo === "?confirmation") {
                    tmppn = "affinity eligibility confirmation";
                    tmpdetailpn = "ultimate employees eligibility confirmation";
                }
                else if (stateInfo.carePathInfo === "?confirmation&fromflow=uploadproof") {
                    tmppn = "affinity eligibility info no work email";
                    tmpdetailpn = "connections eligibility info no work email confirmation";
                }
                else if (stateInfo.carePathInfo === "?confirmation&fromflow=retiree") {
                    tmppn = "affinity eligibility confirmation";
                    tmpdetailpn = "retirees eligibility confirmation";
                }

            }
            else if (InHomeUtils.isNotNull(stateInfo.careFlowTypeInfo) && stateInfo.careFlowTypeInfo === "getaffinity"
                && InHomeUtils.isNotNull(stateInfo.carePathInfo) && stateInfo.carePathInfo.indexOf("urltag=") > 0) {
                let params = new URLSearchParams(window.location.search);
                let urlTagInfo = params.get('Urltag');
                scUserProfileData.verizonUID = urlTagInfo
            }
            else if (InHomeUtils.isNotNull(stateInfo.careFlowTypeInfo) && stateInfo.careFlowTypeInfo === "associationerror"
                && InHomeUtils.isNotNull(stateInfo.careFlowAuthKeyVal)) {
                scUserProfileData.verizonUID = stateInfo.careFlowAuthKeyVal;
                tmppn = "affinity eligibility info error";
                tmpdetailpn = "associations eligibility info error";
            }
            else if (InHomeUtils.isNotNull(stateInfo.careFlowTypeInfo) && stateInfo.careFlowTypeInfo === "association"
                && InHomeUtils.isNotNull(stateInfo.careFlowAuthKeyVal)) {
                scUserProfileData.verizonUID = stateInfo.careFlowAuthKeyVal;
                tmpdetailpn = "associations eligibility info - organisation check";
            }
            else if (InHomeUtils.isNotNull(stateInfo.careFlowTypeInfo) && stateInfo.careFlowTypeInfo === "retiree") {
                if (InHomeUtils.isNotNull(stateInfo.careFlowRetireeInfo) && stateInfo.careFlowRetireeInfo) {
                    tmpdetailpn = "retirees eligibility info";
                }
                else {
                    tmppn = "affinity eligibility info error";
                    tmpdetailpn = "retirees eligibility info error";
                }
            }
            else if (InHomeUtils.isNotNull(stateInfo.carePathInfo) && stateInfo.carePathInfo === "?conflictmessage") {
                tmppn = "affinity eligibility info conflict message";
                tmpdetailpn = "connections eligibility info conflict message";
            }

            initData = Object.assign({}, initData, {
                detailPageName: tmpdetailpn,
                pageName: tmppn,
                events: tmpdetailpn.indexOf("error") > -1 ? "event5,event21" : initData.events
            })
        }

        if (pageInfo === "checkoutMoves") {
            if ((InHomeUtils.isNotNull(stateInfo.cartInfo) && stateInfo.cartInfo.cartOrderProperty === "SEAMLESS") || stateInfo.custflowInfo === "SEAMLESS") {
                initData.contentChannel = "/vz/residential/order/prospect accord seamless move/checkout";
            }
            else {
                initData.contentChannel = "/vz/residential/order/prospect accord move/checkout";
            }
        }

        if (pageInfo === "summaryMoves") {
            if ((InHomeUtils.isNotNull(stateInfo.cartInfo) && stateInfo.cartInfo.cartOrderProperty === "SEAMLESS")
                || stateInfo.custflowInfo === "SEAMLESS"
                || (InHomeUtils.isNotNull(stateInfo.movesInfo) && stateInfo.movesInfo.movesEligibility === "SEAMLESS")) {
                initData.contentChannel = "/vz/residential/order/prospect accord seamless move/confirmation";
            }
            else {
                initData.contentChannel = "/vz/residential/order/prospect accord move/confirmatio";
            }
        }
    }

    let scPageData = {
        "sysEnv": document.domain.indexOf("www.verizon.com") !== -1 ? "prod" : "dev",
        "adobeReportSuite": adobesuite,
        "language": "en_US",
        "pfxID": pfxID,
        "pageName": initData.pageName,
        "detailPageName": initData.detailPageName,
        "businessUnit": (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.appInfo) && InHomeUtils.isNotNull(stateInfo.appInfo.flowType) && (stateInfo.appInfo.flowType === "SUPP" || stateInfo.appInfo.flowType === "AF")) ? "res myverizon" : "residential",
        "pageType": pagetype,
        "contentChannel": initData.contentChannel,
        "lineOfBusiness": lineOfBusiness,
        "cmsPlatform": "res| atlas",
        "applicationName": device,
        "events": initData.events,
        "offerIDClicked": initData.offerid !== undefined ? initData.offerid : "",
        "flowName": flowName,
        "recommendation": "",
        "PEGApropCtgry": "",
        "PEGAnoPropReason": "",
        "PEGAPropositionID": "",
        "PEGAOfferIdentifier": ""
    }
    //Setting Page Data -- Starts


    let scaddrProfileData = { "serviceDMA": "", "serviceCity": "", "productsQualified": "", "servicePostalCode": "", "serviceStateProvince": "", "addressID": "", "maxSpeedQual": "", "statePostLQA": "", "vzwCustomerIdentifier": "", "iontIndicator": "No" }
    let scCartData = { "productsSelected": "", "productsPurchased": "", "totalRecurring": "", "totalNonRecurring": "", "changeAmount": "" }
    let sctransactionData = {
        "MON": "", "installOptions": "", "depositAmount": "", "purchaseID": "", "transactionID": "", "installDate": "", "TwsTransactionID": "",
        "UNID": "", "Startdatetimestamp": "", "Enddatetimestamp": "", "Status": "", "Vendor": "", "TWSsegment": "", "TWSsubgroup": ""
    }


    try {
        if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.appInfo)) {
            getPDCforSC(stateInfo.appInfo.visitorId).then(function (result) {
                scUserProfileData.pdcString = result;
                if (result.hasOwnProperty('meta')) {
                    if (result && result.data) {
                        scUserProfileData.pdcString = result.data;
                    }
                }
            });
        }
    }
    catch (ex) {
        catchJSException('DTMTag', stateInfo.appInfo.visitId, 'getPDCforSC', ex);
    }

    setTimeout(
        function () {
            try {
                let flowType = (stateInfo.appInfo.flowType) ? stateInfo.appInfo.flowType : '';
                if (flowType !== 'AF') {
                    if (pageInfo === "buildFiosInit" || pageInfo === "buildFiosSupp" || pageInfo === "checkoutInit" || pageInfo === "quickcheckoutInit" || pageInfo === "checkoutInitSupp" || pageInfo === "summaryInit" || pageInfo === "quickcheckoutsummaryInit" || pageInfo === "summaryInitSupp" || pageInfo === "seamlessMoves" || pageInfo === "nonSeamlessMoves" || pageInfo === "checkoutMoves" || pageInfo === "summaryMoves" || pageInfo === "buildFiosMoves" || pageInfo === "buildTwsInit") {
                        let dmavalue = window.sessionStorage.getItem('dma');
                        if (InHomeUtils.isNotNull(dmavalue))
                            scaddrProfileData.DMAPostLQA = dmavalue

                        if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.lqInfo) && stateInfo.lqInfo.iONTEligible) {
                            scaddrProfileData.iontIndicator = "Yes";
                            tempSCData.IONTEligible = true;
                            if (InHomeUtils.isNotNull(stateInfo.appInfo)) {
                                logOtherInfo(detailsInfo(pageInfo, stateInfo.appInfo.visitId, 'Inside DTM', "IONT Eligible", PAGEACTIVITY.UA));
                            }
                        }
                        else {
                            if (InHomeUtils.isNotNull(stateInfo.appInfo)) {
                                logOtherInfo(detailsInfo(pageInfo, stateInfo.appInfo.visitId, 'Inside DTM', "IONT NOT Eligible", PAGEACTIVITY.UA));
                            }
                        }

                        if (pageInfo === "buildFiosInit" || pageInfo === "buildFiosSupp" || pageInfo === "checkoutInit" || pageInfo === "quickcheckoutInit" || pageInfo === "checkoutInitSupp" || pageInfo === "summaryInit" || pageInfo === "quickcheckoutsummaryInit" || pageInfo === "summaryInitSupp")
                            scUserProfileData.customerCategory = "^New^";
                        else
                            scUserProfileData.customerCategory = "^Moves^"; // If existing customer category change here variable c69  -- refer getCustomerCategory in bau code vendortagutils
                        if (pageInfo === "buildFiosInit" || pageInfo === "buildFiosSupp" || pageInfo === "checkoutInit") {
                            if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.lqInfo)) {
                                scaddrProfileData.addressID = (InHomeUtils.isNotNull(stateInfo.lqInfo.selectedUnit)
                                    && InHomeUtils.isNotNull(stateInfo.lqInfo.selectedUnit.addressId)
                                    && stateInfo.lqInfo.selectedUnit.addressId !== ""
                                    && stateInfo.lqInfo.selectedUnit.addressId !== "N") ? stateInfo.lqInfo.selectedUnit.addressId : (InHomeUtils.isNotNull(stateInfo.lqInfo.selectedAdr) ? stateInfo.lqInfo.selectedAdr.addressID : 0);
                                tempSCData.addressID = scaddrProfileData.addressID;
                                scaddrProfileData.productsQualified = 'nc-';
                                let srvcs = stateInfo.lqInfo.lqResponse.services
                                for (let i = 0; i < srvcs.length; i++) {
                                    if (srvcs[i].qualified === 'Y' && srvcs[i].servicename === 'FiOSData') {
                                        scaddrProfileData.productsQualified += scaddrProfileData.productsQualified !== 'nc-' ? '+fdata' : 'fdata';
                                    } else if (srvcs[i].qualified === 'Y' && srvcs[i].servicename === 'Video') {
                                        scaddrProfileData.productsQualified += scaddrProfileData.productsQualified !== 'nc-' ? '+ftv' : 'ftv';
                                    } else if (srvcs[i].qualified === 'Y' && srvcs[i].servicename === 'Voice') {
                                        scaddrProfileData.productsQualified += scaddrProfileData.productsQualified !== 'nc-' ? '+fphone' : 'fphone';
                                    }

                                    //  } else if (srvcs[i].qualified === 'Y' && srvcs[i].servicename === 'HSI') {
                                    //      scaddrProfileData.productsQualified += scaddrProfileData.productsQualified !== 'nc-' ? '+hsidata' : 'hsidata';
                                    //  }
                                }
                                tempSCData.productsQualified = scaddrProfileData.productsQualified;
                            }
                        }

                        if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.lqInfo)) {
                            scaddrProfileData.servicePostalCode = stateInfo.lqInfo.selectedState.zip;
                            tempSCData.servicePostalCode = stateInfo.lqInfo.selectedState.zip;
                            //scaddrProfileData.serviceStateProvince = stateInfo.lqInfo.selectedState.state;
                            if (pageInfo === "seamlessMoves" || pageInfo === "nonSeamlessMoves") {
                                if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.movesInfo) && InHomeUtils.isNotNull(stateInfo.movesInfo.maxSpeedQual))
                                    scaddrProfileData.maxSpeedQual = stateInfo.movesInfo.maxSpeedQual;
                                tempSCData.maxSpeedQual = stateInfo.movesInfo.maxSpeedQual;
                            }
                            else {
                                let buildProductState = store && store.getState && store.getState().buildProduct;
                                let maxSpeedQual = "";
                                let speedPrds = [];
                                let productArray = [];
                                if (buildProductState.internet.m2mPlans.length !== 0) {
                                    productArray = buildProductState.internet.m2mPlans;
                                }
                                else if (buildProductState.internet.twoYearPlans.length !== 0) {
                                    productArray = buildProductState.internet.twoYearPlans;
                                }
                                productArray.map(obj => {
                                    if (obj.name.indexOf("Giga") > -1) {
                                        speedPrds.push("1000");
                                    }
                                    else {
                                        if (obj.downSpeed !== undefined && obj.downSpeed !== null)
                                            speedPrds.push(obj.downSpeed.replace("M", ""));
                                    }
                                })
                                speedPrds.sort(function (a, b) { return b - a });
                                if (speedPrds.length > 0) {
                                    maxSpeedQual = speedPrds[0] + "/" + speedPrds[0];
                                }
                                scaddrProfileData.maxSpeedQual = stateInfo ?.maxSpeedQual ? stateInfo.maxSpeedQual : maxSpeedQual;
                                tempSCData.maxSpeedQual = scaddrProfileData.maxSpeedQual;
                            }
                            scaddrProfileData.statePostLQA = stateInfo.lqInfo.selectedState.state;
                            tempSCData.statePostLQA = scaddrProfileData.statePostLQA;

                        }

                        if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.lqInfo) && InHomeUtils.isNotEmpty(stateInfo.lqInfo.vzwOffer) && stateInfo.lqInfo.vzwOffer.indexOf("VZWADVOFFERELIGIBLE:Y") > -1) {
                            scaddrProfileData.vzwCustomerIdentifier = 'vzw customer';
                        }
                        else {
                            scaddrProfileData.vzwCustomerIdentifier = 'non - vzw customer';
                        }
                        tempSCData.vzwCustomerIdentifier = scaddrProfileData.vzwCustomerIdentifier;
                        if (pageInfo === "seamlessMoves" || pageInfo === "buildFiosMoves" || pageInfo === "nonSeamlessMoves") {
                            scaddrProfileData.productsQualified = 'moves-';
                            let srvcs = stateInfo.lqInfo.lqResponse.services
                            for (let i = 0; i < srvcs.length; i++) {
                                if (srvcs[i].qualified === 'Y' && srvcs[i].servicename === 'FiOSData') {
                                    scaddrProfileData.productsQualified += scaddrProfileData.productsQualified !== 'moves-' ? '+fdata' : 'fdata';
                                } else if (srvcs[i].qualified === 'Y' && srvcs[i].servicename === 'Video') {
                                    scaddrProfileData.productsQualified += scaddrProfileData.productsQualified !== 'moves-' ? '+ftv' : 'ftv';
                                } else if (srvcs[i].qualified === 'Y' && srvcs[i].servicename === 'Voice') {
                                    scaddrProfileData.productsQualified += scaddrProfileData.productsQualified !== 'moves-' ? '+fphone' : 'fphone';
                                }
                                //else if (srvcs[i].qualified === 'Y' && srvcs[i].servicename === 'HSI') {
                                //      scaddrProfileData.productsQualified += scaddrProfileData.productsQualified !== 'moves-' ? '+hsidata' : 'hsidata';
                                //  }
                            }
                            tempSCData.productsQualified = scaddrProfileData.productsQualified
                        }

                        if (pageInfo === "summaryInit" || pageInfo === "quickcheckoutsummaryInit" || pageInfo === "summaryMoves" || pageInfo === "summaryInitSupp" || pageInfo === "checkoutInitSupp") {
                            if (pageInfo !== "checkoutInitSupp") {
                                if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.lqInfo)) {
                                    scaddrProfileData.statePostLQA = stateInfo.lqInfo.selectedState.state;
                                    scaddrProfileData.servicePostalCode = stateInfo.lqInfo.selectedState.zip;
                                    scaddrProfileData.serviceStateProvince = stateInfo.lqInfo.selectedState.state;
                                    scaddrProfileData.serviceCity = stateInfo.lqInfo.selectedState.altCity;
                                    scaddrProfileData.serviceCountry = "USA";
                                }
                            }

                            if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.checkoutInfo)) {
                                let installTypeSO = " tech equip";
                                if (InHomeUtils.isNotNull(stateInfo.creditInfo) && stateInfo.creditInfo.isCreditCheckCleared) {
                                    let noofdays = "";
                                    let directShip = "";
                                    let dt2 = new Date(stateInfo.checkoutInfo.selInstallDate);//new Date(stateInfo.checkoutInfo.selInstallDate);
                                    let dt1 = "";
                                    let strdaysgapformat = "fios:";

                                    if (stateInfo.checkoutInfo.selDueDateType === "TECHVISIT") {
                                        strdaysgapformat = strdaysgapformat + (stateInfo.checkoutInfo.showDirectShipSection ? "freetech + directship " : "freetech");
                                    }
                                    else {
                                        installTypeSO = " special install"
                                        strdaysgapformat = strdaysgapformat + (stateInfo.checkoutInfo.selDeliveryOption === "PickUp" ? "selfstoreormail" : "self");
                                    }
                                    try {
                                        if (stateInfo.checkoutInfo.calenderDisplayArr != null) {
                                            dt1 = new Date(stateInfo.checkoutInfo.calenderDisplayArr[0]);
                                        }
                                        else {
                                            dt1 = new Date(stateInfo.checkoutInfo.dueDateArr[0]);
                                        }

                                        noofdays = Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
                                    }
                                    catch (ex) {
                                        catchJSException('DTMTag', stateInfo.appInfo.visitId, 'Init-Calc-noofDays', ex);
                                    }
                                    if (stateInfo.checkoutInfo.showDirectShipSection) {
                                        if (stateInfo.checkoutInfo.dsInput === 'rdoDSYes' || stateInfo.checkoutInfo.dsInput === 'rdoEarlyDSYes') {
                                            directShip = "directship :Yes";
                                            installTypeSO = " equip mailed"
                                        }
                                        else if (stateInfo.checkoutInfo.dsInput === 'rdoDSNo' || stateInfo.checkoutInfo.dsInput === 'rdoEarlyDSNo') {
                                            directShip = "directship :No";
                                        }
                                    }

                                    strdaysgapformat += " ^" + noofdays + "d | ";

                                    if (stateInfo.checkoutInfo.selDueDateType !== "TECHVISIT") {
                                        strdaysgapformat = strdaysgapformat + (stateInfo.checkoutInfo.selDeliveryOption === "PickUp" ? "self install store" : "self install");
                                    }
                                    else {
                                        strdaysgapformat = strdaysgapformat + directShip + "^" + noofdays + "d"
                                    }

                                    sctransactionData.installDate = stateInfo.checkoutInfo.selInstallDate;
                                    sctransactionData.installOptions = strdaysgapformat;

                                    scUserProfileData.creditCheck = "Pass";
                                }

                                else {
                                    scUserProfileData.creditCheck = "Fail";
                                    installTypeSO = " credit fail"
                                }

                                if (pageInfo !== "checkoutInitSupp" && pageInfo !== "summaryInitSupp") {
                                    scPageData.detailPageName = "accord| order confirmation|" + installTypeSO;
                                }

                                if (InHomeUtils.isNotNull(stateInfo.creditInfo) && stateInfo.creditInfo.isDepositRequired) {
                                    scUserProfileData.depositAsked = "Y";
                                    scUserProfileData.depositPaid = "Y";
                                    if (InHomeUtils.isNotNull(stateInfo.creditInfo.creditCheckResponse)
                                        && InHomeUtils.isNotNull(stateInfo.creditInfo.creditCheckResponse.icredit) && InHomeUtils.isNotNull(stateInfo.creditInfo.creditCheckResponse.icredit.depositinfo)) {
                                        sctransactionData.depositAmount = "$" + stateInfo.creditInfo.creditCheckResponse.icredit.depositinfo.depositamount;
                                    }
                                }
                                else {
                                    scUserProfileData.depositAsked = "N";
                                    scUserProfileData.depositPaid = "N";
                                }
                            }
                        }


                        let srvcsOrdered = ""
                        if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.cartInfo)) {
                            let val = ""
                            let contractType = "";
                            let isbundle = false;
                            if (InHomeUtils.isNotNull(stateInfo.cartInfo.cartOrderDetail)) {
                                srvcsOrdered = stateInfo.cartInfo.cartOrderDetail.servicesOrdered;
                                isbundle = stateInfo.cartInfo.cartOrderDetail.bundle;
                                contractType = stateInfo.cartInfo.cartOrderDetail.contract !== undefined && stateInfo.cartInfo?.cartOrderDetail?.contract.indexOf("TWOYEAR") > -1 ? "TwoYears" : "MonthToMonth";
                            }

                            srvcsOrdered = (InHomeUtils.isNotNull(stateInfo.cartInfo.cartOrderDetail) && InHomeUtils.isNotNull(srvcsOrdered)) ? srvcsOrdered.replace("DATA", "fdata").replace("VIDEO", "ftv").replace("FIOS_VOICE", "fphone") : "";

                            if (srvcsOrdered !== "") {
                                let srvcs = srvcsOrdered.split(',');
                                if (srvcs.length === 3) {
                                    val = "triple - "
                                }
                                else if (srvcs.length === 2) {
                                    val = "double - "
                                }
                                else {
                                    val = "single - "
                                }
                                val = val + srvcsOrdered.replace(/,/g, "+");
                            }

                            scCartData.productsSelected = val;
                            if (pageInfo === "summaryInit" || pageInfo === "quickcheckoutsummaryInit" || pageInfo === "summaryMoves" || pageInfo === "summaryInitSupp") {
                                scCartData.productsPurchased = val;
                            }

                            scUserProfileData.contractType = contractType;
                            tempSCData.bundleSelected = val;
                        }
                    }


                    if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.appInfo) && (pageInfo === "summaryInit" || pageInfo === "quickcheckoutsummaryInit" || pageInfo === "summaryInitSupp" || pageInfo === "summaryMoves")) {
                        sctransactionData.MON = stateInfo.appInfo.mon_no;
                        sctransactionData.purchaseID = stateInfo.appInfo.mon_no;
                        sctransactionData.transactionID = stateInfo.appInfo.visitId;
                        tempSCData.events = "";
                    }
                    else if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.appInfo) && stateInfo.isSmartCartFlow) {
                        sctransactionData.MON = stateInfo.appInfo.mon_no;
                    }

                    if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.appInfo)) {
                        scUserProfileData.sessionIDs = stateInfo.appInfo.visitorId;
                        scUserProfileData.channelSession = stateInfo.appInfo.visitId;
                    }
                    if (stateInfo.appInfo.flowType === "SUPP" && InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.suppInfo) && InHomeUtils.isNotNull(stateInfo.suppInfo.commondetails)) {
                        sctransactionData.purchaseID = stateInfo.suppInfo.commondetails.monno + "|" + stateInfo.suppInfo.commondetails.zip;
                        sctransactionData.MON = stateInfo.suppInfo.commondetails.monno + "|" + stateInfo.suppInfo.commondetails.zip;
                    }
                }
                else if (flowType == 'AF') {
                    try {
                        if ((pageInfo == 'pega' || pageInfo == 'urcConfirmation' || pageInfo == 'tvRecommender' || pageInfo == 'disconnect') && data != null) {
                            if (data.page != null) {
                                scPageData = { ...scPageData, ...data.page };
                            }

                            if (data.userProfile != null) {
                                scUserProfileData = { ...scUserProfileData, ...data.userProfile };
                            }

                            if (data.addrProfile != null) {
                                scaddrProfileData = { ...scaddrProfileData, ...data.addrProfile }
                            }

                            if (data.existingProduct != null) {
                                scExistingProductData = data.existingProduct
                            }

                            if (data.transactionData != null) {
                                sctransactionData = { ...sctransactionData, ...data.transactionData }
                            }

                            let srvcsOrdered = ""
                            let val = ""
                            if (InHomeUtils.isNotNull(stateInfo.cartInfo) && InHomeUtils.isNotNull(stateInfo.cartInfo.orderDetail) && InHomeUtils.isNotNull(stateInfo.cartInfo.orderDetail.servicesOrdered)) {
                                srvcsOrdered = stateInfo.cartInfo.orderDetail.servicesOrdered;
                            }
                            srvcsOrdered = (InHomeUtils.isNotNull(stateInfo.cartInfo.orderDetail) && InHomeUtils.isNotNull(srvcsOrdered)) ? srvcsOrdered.replace("DATA", "fdata").replace("VIDEO", "ftv").replace("FIOS_VOICE", "fphone") : "";

                            if (srvcsOrdered !== "") {
                                let srvcs = srvcsOrdered.split(',');
                                if (srvcs.length === 3) {
                                    val = "triple - "
                                }
                                else if (srvcs.length === 2) {
                                    val = "double - "
                                }
                                else {
                                    val = "single - "
                                }
                                val = val + srvcsOrdered.replace(/,/g, "+");
                            }
                            scCartData.productsSelected = val;

                            if (pageInfo === "urcConfirmation") {
                                scCartData.productsPurchased = val;
                            }
                        }
                        else {
                            if (data) {

                                if (data.addrProfile != null) {
                                    scaddrProfileData = { ...scaddrProfileData, ...data.addrProfile }
                                }

                                if (data.existingProduct) {
                                    scExistingProductData = data.existingProduct
                                }

                                let srvcsOrdered = ""
                                if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.cartInfo)) {
                                    let val = ""
                                    if (InHomeUtils.isNotNull(stateInfo.cartInfo.cartOrderDetail)) {
                                        srvcsOrdered = stateInfo.cartInfo.cartOrderDetail.servicesOrdered;
                                    }

                                    srvcsOrdered = (InHomeUtils.isNotNull(stateInfo.cartInfo.cartOrderDetail) && InHomeUtils.isNotNull(srvcsOrdered)) ? srvcsOrdered.replace("DATA", "fdata").replace("VIDEO", "ftv").replace("FIOS_VOICE", "fphone") : "";

                                    if (srvcsOrdered !== "") {
                                        let srvcs = srvcsOrdered.split(',');
                                        if (srvcs.length === 3) {
                                            val = "triple - "
                                        }
                                        else if (srvcs.length === 2) {
                                            val = "double - "
                                        }
                                        else {
                                            val = "single - "
                                        }
                                        val = val + srvcsOrdered.replace(/,/g, "+");
                                    }

                                    scCartData.productsSelected = val;
                                    if (pageInfo === "summaryInit") {
                                        scCartData.productsPurchased = val;
                                    }

                                    if (stateInfo.cartInfo.cartResponse && stateInfo.cartInfo.cartResponse.tierContent && stateInfo.cartInfo.cartResponse.tierContent[0]) {
                                        scCartData.totalRecurring = stateInfo.cartInfo.cartResponse.tierContent[0].monthlyRcPrice.replace("$", "");
                                        scCartData.totalNonRecurring = stateInfo.cartInfo.cartResponse.tierContent[0].totalNrcPrice.replace("$", "");
                                        scCartData.changeAmount = stateInfo.cartInfo.cartResponse.tierContent[0].totalMonthlyPrice.replace("$", "");
                                    }
                                }
                            }
                        }
                    }
                    catch (ex) {
                        catchJSException('AF', stateInfo.appInfo.visitId, 'SetDTMDetailsAF', ex);
                    }
                }
            }
            catch (ex) {
                catchJSException('DTMTag', stateInfo.appInfo.visitId, 'DTMInit', ex);
            }

            //If supp flow add profile data
            if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.appInfo) && stateInfo.appInfo.flowType === "SUPP" && InHomeUtils.isNotNull(stateInfo.profileInfo)) {
                scUserProfileData.customerType = getCustomerType(stateInfo.profileInfo);
            }

            //If EC flow add profile data
            if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.appInfo) && stateInfo.appInfo.flowType === "AF" && InHomeUtils.isNotNull(stateInfo.signInInfo) && InHomeUtils.isNotNull(stateInfo.signInInfo.response) && InHomeUtils.isNotNull(stateInfo.signInInfo.response.userProfile) && InHomeUtils.isNotNull(stateInfo.signInInfo.response.userProfile.customerType)) {
                scUserProfileData.customerType = stateInfo.signInInfo.response.userProfile.customerType;
            }

            if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.profileDTMPrdInfo)) {
                tempSCData.profileProduct = stateInfo.profileDTMPrdInfo;
            }

            let newEvent = {
                "page": scPageData,
                "userProfile": scUserProfileData,
                "addrProfile": scaddrProfileData,
                "cart": scCartData,
                "transaction": sctransactionData,
                "product": [],
                "existingProduct": scExistingProductData
            }

            window.digitalData = newEvent;

            let newPageViewEvent = {
                eventInfo: { eventName: "pageViewUpdate", timeStamp: new Date(), processed: { adobeAnalytics: false } },
                scEvents: initData.events,
                product: []
            };

            if (pageInfo === "checkAvaillqInit") {
                tempSCData.isDTMCallCompleted = true;
            }
            else if (pageInfo === "buildFiosInitEC") {
                newPageViewEvent.eventInfo.action = "Content load on first page view";
                newPageViewEvent.eventInfo.eventName = "pageView";
                newPageViewEvent.eventInfo.type = "EC Ordering"
                newPageViewEvent.scEvents = "event88";
            }

            if (pageInfo === "buildFiosInit" || pageInfo === "buildFiosSupp" || pageInfo === "checkoutInit" || pageInfo === "quickcheckoutInit" || pageInfo === "checkoutInitSupp" || pageInfo === "summaryInit" || pageInfo === "quickcheckoutsummaryInit" || pageInfo === "summaryInitSupp" || pageInfo === "seamlessMoves" || pageInfo === "checkoutMoves" || pageInfo === "summaryMoves" || pageInfo === "buildFiosMoves" || pageInfo === "nonSeamlessMoves") {
                //if (pageInfo === "checkoutInit" || pageInfo === "summaryInit") {
                if (InHomeUtils.isNotNull(stateInfo)
                    && InHomeUtils.isNotNull(stateInfo.cartInfo)
                    && InHomeUtils.isNotNull(stateInfo.cartInfo.cartResponse) && InHomeUtils.isNotNull(stateInfo.cartInfo.cartOrderDetail)) {
                    newPageViewEvent.product = getProductObject(stateInfo.cartInfo.cartOrderDetail, stateInfo.cartInfo.cartResponse, stateInfo.appInfo.flowType);
                    tempSCData.product = newPageViewEvent.product;
                }
            }
            else if (pageInfo === "pega") {
                newPageViewEvent.scEvents = data.page.events;
                if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.cartInfo) && InHomeUtils.isNotNull(stateInfo.cartInfo.orderDetail) && InHomeUtils.isNotNull(stateInfo.cartInfo.tierPricing)) {
                    newPageViewEvent.product = getProductObject(stateInfo.cartInfo.orderDetail, stateInfo.cartInfo.tierPricing, stateInfo.appInfo.flowType);
                    tempSCData.product = newPageViewEvent.product;
                    window.digitalData.product = tempSCData.product;
                }
            }


            window.digitalData = window.digitalData || {};
            window.digitalData.events = window.digitalData.events || [];
            window.digitalData.events.push(newPageViewEvent);
            // console.log(window.digitalData);
            sendCustomEvent("pageViewUpdate");

            if ((pageInfo === "buildFiosInit" || pageInfo === "buildFiosSupp" || pageInfo === "buildFiosMoves" || pageInfo === "seamlessMoves")
                && InHomeUtils.isNotNull(stateInfo.lqInfo) && stateInfo.lqInfo.MFRTEligible) {
                let linkvalMFRT = "";
                if (stateInfo.lqInfo.isFCPflow && InHomeUtils.isNotNull(stateInfo.lqInfo.sweetnerMsgMFRT)
                    && InHomeUtils.isNotNull(stateInfo.lqInfo.sweetnerMsgMFRT.discountEligible) && stateInfo.lqInfo.sweetnerMsgMFRT.discountEligible) {
                    linkvalMFRT = (pageInfo === "seamlessMoves") ? "eligible for tws discount - seamlessmove" : "eligible for tws discount";
                }
                else {
                    if (!stateInfo.lqInfo.isFCPflow) {
                        linkvalMFRT = (pageInfo === "seamlessMoves") ? "not eligible for tws discount - non fcp - seamlessmove" : "not eligible for tws discount - non fcp";
                    }
                    else {
                        linkvalMFRT = (pageInfo === "seamlessMoves") ? "not eligible for tws discount - seamlessmove" : "not eligible for tws discount";
                    }
                }

                updateSCTags(linkvalMFRT);
            }


            //console.log(JSON.stringify(window.digitalData))
        }.bind(this), 2000);

}

var retrySendCustomEventCount = 0;

const getCustomerType = (profileInfo) => {
    let sCustomerType = "";

    let profileDataService = "";
    let profileTvService = "";
    let profileVoiceService = "";

    if (InHomeUtils.isNotNull(profileInfo.cartData) && InHomeUtils.isNotNull(profileInfo.cartData[0]) && InHomeUtils.isNotNull(profileInfo.cartData[0].serviceHeaders)) {
        profileInfo.cartData[0].serviceHeaders.servicehead.map((svcObj) => {
            if (svcObj.prodType === "BASIC") {
                profileTvService = svcObj.prodTypeVal;
            }

            if (svcObj.prodType === "FTTPD") {
                profileDataService = svcObj.prodName;
            }
            if (svcObj.prodType === "FVPRIMARY") {
                profileVoiceService = svcObj.prodName;
            }

        });
    }

    sCustomerType = "eofphone" + profileVoiceService + "-" + "eofios " + profileDataService + "-" + "eofios tv " + profileTvService;

    return sCustomerType;
}

const getFlowName = (stateInfo, pageInfo, flowName) => {
    let sFlowName = flowName;

    if (InHomeUtils.isNotNull(pageInfo)) {
        if (pageInfo === "nonSeamlessMoves" || pageInfo === "buildFiosMoves" || (pageInfo === "checkAvaillqInit" && InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.appInfo) && stateInfo.appInfo.flowType === "MV")) {
            sFlowName = "prospect accord move";
        }
        else if (pageInfo === "seamlessMoves") {
            sFlowName = "prospect accord seamless move";
        }
        else if (pageInfo === "quickcheckoutInit" || pageInfo === "quickcheckoutsummaryInit")
            sFlowName = sFlowName + "| quick checkout";
        else if (pageInfo == 'buildFiosInitEC')
            sFlowName = 'urc| acrdflow/am - mix match';

        if (pageInfo === "careFlowPageInit" || pageInfo === "entrypointInit")
            sFlowName = "prospect";
    }

    if (InHomeUtils.isNotNull(stateInfo)) {
        if (InHomeUtils.isNotNull(stateInfo.appInfo) && stateInfo.appInfo.flowType === "SUPP") {
            sFlowName = "acrd supp-order";
        }
        if (InHomeUtils.isNotNull(stateInfo.appInfo) && stateInfo.appInfo.flowType === "AF" && pageInfo != 'buildFiosInitEC') {
            sFlowName = "urc| upgrade/renewal| atom";
        }
        if (InHomeUtils.isNotNull(stateInfo.lqInfo) && (stateInfo.lqInfo.isFCPflow || stateInfo.lqInfo.isFcpInProfile)) {
            sFlowName = sFlowName + "| mix match";
        }
        if (InHomeUtils.isNotNull(stateInfo.lqInfo) && (stateInfo.lqInfo.lqResponse.hoaFlag === "Y")) {
            sFlowName = sFlowName + "| vvp";
        }
        if (InHomeUtils.isNotNull(stateInfo.appInfo) && InHomeUtils.isNotNull(stateInfo.appInfo.vendor)
            && InHomeUtils.isNotEmpty(stateInfo.appInfo.vendor.vendorName)) {
            if (stateInfo.appInfo.vendor.vendorName === "RedVentures") {
                sFlowName = sFlowName + "| rv";
            }
            else if (stateInfo.appInfo.vendor.vendorName === "Clearlink") {
                sFlowName = sFlowName + "| cl";
            }
            else if (stateInfo.appInfo.vendor.vendorName === "Target") {
                sFlowName = sFlowName + "| target";
            }
            else if (stateInfo.appInfo.vendor.vendorName === "Quology") {
                sFlowName = sFlowName + "| Qo";
            }
            else {
                sFlowName = sFlowName + "| " + stateInfo.appInfo.vendor.vendorName;
            }
        }

        if (InHomeUtils.isNotNull(stateInfo.appInfo) && stateInfo.appInfo.flowType === "MV"
            && (pageInfo === "checkoutMoves" || pageInfo === "summaryMoves")) {
            if ((InHomeUtils.isNotNull(stateInfo.cartInfo) && stateInfo.cartInfo.cartOrderProperty === "SEAMLESS")
                || (InHomeUtils.isNotNull(stateInfo.moveExp_Cust) && (stateInfo.moveExp_Cust === "SEAMLESS"))) {
                sFlowName = "prospect accord seamless move";
            }
            else {
                sFlowName = "prospect accord move";
            }

            if ((InHomeUtils.isNotNull(stateInfo.lqInfo) && InHomeUtils.isNotNull(stateInfo.lqInfo.isFCPflow) && stateInfo.lqInfo.isFCPflow)) {
                sFlowName = sFlowName + "| mix match";
            }
        }
    }

    return sFlowName;
}

export const tempSCData = {
    pageName: "",
    detailPageName: "",
    contentChannel: "",
    events: "",
    statePostLQA: "",
    productsQualified: "",
    maxSpeedQual: "",
    servicePostalCode: "",
    flowName: "",
    bundleSelected: "",
    product: [],
    depositAmount: "",
    installOptions: "",
    MON: "",
    serviceDMA: "",
    newnewRepeatXP1: "",
    creditCheck: "",
    creditCheckstatus: "",
    customerCategory: "",
    isMixMatch: false,
    profileProduct: [],
    IONTEligible: false,
    isSUPPflow: false,
    isDTMCallCompleted: false,
    TwsTransactionID: "",
    UNID: "",
    Startdatetimestamp: "",
    Enddatetimestamp: "",
    Status: "",
    Vendor: "",
    TWSsegment: "",
    TWSsubgroup: ""
};

export const scDataDetails = {
    accountAccess: { pageName: "nclick| account access", detailPageName: "nclick| account access| give permission" },
    urcConfirmation: { pageName: "nclick| renewal| pega| order confirmation", detailPageName: "atom| nclick| renewal| pega| order confirmation", events: "event5,event40,event42,event43,event44,event55,purchase" },
    disconnect: { pageName: "disconnect", detailPageName: "atom| accord| disconnect| disconnect date", events: "event5, event20" },
    tvRecommender: { pageName: "TVRecommender", detailPageName: "TVRecommender", events: "event5" },
    pega: { pageName: "pega", detailPageName: "pega" },
    checkAvaillqInit: { pageName: "lq check avail", detailPageName: "lq check avail", contentChannel: "/vz/residential/order/prospect/lqfull", events: "event5" },
    holidayOfferOverlay: { contentChannel: "/vz/residential/order/prospect accord/select" },
    blackfridayOfferOverlay: { contentChannel: "/vz/residential/order/prospect accord/select" },
    multipleAddress: { pageName: "lq multiple address", detailPageName: "lq multiple address", contentChannel: "/vz/residential/order/prospect/lqfull", events: "event5" },
    outOfFranchise: { pageName: "out of franchise", detailPageName: "street address oof", contentChannel: "/vz/residential/order/prospect/lqfull", events: "event5,event8,event88,event11" },
    //fiveGOOF: {pageName: "out of franchise", detailPageName: "5g out of franchise", contentChannel: "/vz/residential/order/prospect/lqfull", events: "event5,event8,event88,event11"},    
    existingSrvc: { pageName: "existing service", detailPageName: "existing service", events: "event5", contentChannel: "/vz/residential/order/prospect/lqfull" },
    addrVerification: { pageName: "lq address verification", detailPageName: "lq address verification", events: "event5, event8" },
    pendingOrder: { pageName: "pending order", detailPageName: "pending order", events: "event5", contentChannel: "/vz/residential/order/prospect/lqfull" },
    smartSave: { pageName: "smart cart resume entry options", detailPageName: "", events: "event5", contentChannel: "/vz/residential/order/prospect accord/smart cart", flowName: "prospect accord" },
    smartResumeError: { pageName: "smart cart resume entry", detailPageName: "smart cart resume entry| not available online", events: "event5, event62", contentChannel: "/vz/residential/order/prospect accord/smart cart", flowName: "prospect accord" },
    smartResumeEntry: { pageName: "smart cart resume entry", detailPageName: "continue your cart", events: "event5, event62", contentChannel: "/vz/residential/order/prospect accord/smart cart", flowName: "prospect accord" },
    help: { pageName: "lq help", detailPageName: "lq help", events: "event5", contentChannel: "/vz/residential/order/prospect/lqfull" },
    buildFiosInit: { pageName: "byob", detailPageName: "byob", contentChannel: "/vz/residential/order/prospect accord/select", events: "event5,event90,event99,scOpen" },
    faq: { pageName: "faq", detailPageName: "faq", events: "event5,event12,event90,event99,prodView", contentChannel: "/vz/residential/order/prospect/faq", flowName: "prospect accord| mix match" },
    accordionOpen: { pageName: "byob", detailPageName: "", events: "event5,event15,event20,event46", contentChannel: "/vz/residential/order/prospect accord/select" },
    accordionOpenMoves: { pageName: "byob", detailPageName: "", events: "event5,event15,event20,event46", contentChannel: "/vz/residential/order/prospect accord move/select" },
    cartAddService: { pageName: "byob", detailPageName: "", events: "event5,event15,event20,scAdd,event46", bundleSelected: "", contentChannel: "/vz/residential/order/prospect accord/select" },
    cartAddServiceMoves: { pageName: "byob", detailPageName: "", events: "event5,event15,event20,scAdd,event46", bundleSelected: "", contentChannel: "/vz/residential/order/prospect accord move/select" },
    cartAddServiceSupp: { pageName: "accord supp| updated order", detailPageName: "fios| accord supp| updated order", events: "event5,scOpen,event90,event99,event46,scAdd", contentChannel: "/vz/residential/order/prospect accord/select" },
    rafRedeemLoad: { pageName: "byob", detailPageName: "byob| raf code redeem", events: "event5,event15,event20,event46", contentChannel: "/vz/residential/order/prospect accord/select" },
    ffRedeemLoad: { pageName: "byob", detailPageName: "byob| raf code redeem", events: "event5,event15,event20,event46", contentChannel: "/vz/residential/order/prospect accord/select" },
    vzcRedeemLoad: { pageName: "byob", detailPageName: "byob| raf code redeem", events: "event5,event15,event20,event46", contentChannel: "/vz/residential/order/prospect accord/select" },

    rafRedeemOrderSummaryLoad: { pageName: "byob", detailPageName: "byob| raf code redeem", events: "event5,event15,event20,event46", contentChannel: "/vz/residential/order/prospect accord/select" },
    ffRedeemOrderSummaryLoad: { pageName: "byob", detailPageName: "byob| raf code redeem", events: "event5,event15,event20,event46", contentChannel: "/vz/residential/order/prospect accord/select" },
    vzcRedeemOrderSummaryLoad: { pageName: "byob", detailPageName: "byob| raf code redeem", events: "event5,event15,event20,event46", contentChannel: "/vz/residential/order/prospect accord/select" },

    winBackLoad: { pageName: "byob", detailPageName: "byob| phone winback", events: "event5,event15,event20,scAdd,event46", contentChannel: "/vz/residential/order/prospect accord/select" },
    discoveryOff: { pageName: "byob", detailPageName: "byob", events: "event5,event15,event20,event46", contentChannel: "/vz/residential/order/prospect accord/select" },
    winBackPage: { pageName: "byob", detailPageName: "byob| phone winback", events: "event5,event15,event20,scAdd,event46", contentChannel: "/vz/residential/order/prospect accord/select" },
    saveInit: { pageName: "smart cart save", detailPageName: "", events: "event5", contentChannel: "/vz/residential/order/prospect accord/smart cart", flowName: "prospect accord" },
    saveProactive: { pageName: "smart cart save", detailPageName: "", events: "event5", contentChannel: "/vz/residential/order/prospect accord/smart cart", flowName: "prospect accord" },
    savePassive: { pageName: "smart cart save", detailPageName: "", events: "event5,event22", contentChannel: "/vz/residential/order/prospect accord/smart cart", flowName: "prospect accord" },
    checkoutInit: { pageName: "info and credit", detailPageName: "accord| info and credit - billinfo", events: "event5,event13,event14,scCheckout", contentChannel: "/vz/residential/order/prospect accord/checkout" },
    quickcheckoutInit: { pageName: "info and credit", detailPageName: "accord| info and credit - billinfo", events: "event5,event13,event14,scCheckout,event5,event90,event99,scOpen", contentChannel: "/vz/residential/order/prospect accord/checkout" },
    checkoutInitSupp: { pageName: "accord supp| checkout", detailPageName: "fios| accord supp| checkout", events: "scCheckout,event5,event13,event14", contentChannel: "/vz/residential/myverizon/whats+next/fios/acrd supp order" },
    //checkoutInitFCP: { pageName: "info and credit", detailPageName: "accord| info and credit - billinfo", events: "event5,event13,event14,scCheckout", contentChannel: "/vz/residential/order/prospect accord/checkout",flowName: "prospect accord|mix match" },       
    checkoutInitMoves: { pageName: "info and credit", detailPageName: "accord| info and credit - billinfo", events: "event5,event13,event14,scCheckout", contentChannel: "/vz/residential/order/prospect accord seamless move/checkout" },
    checkoutInitNonSeamless: { pageName: "info and credit", detailPageName: "accord| info and credit - billinfo", events: "event5,event13,event14,scCheckout", contentChannel: "/vz/residential/order/prospect accord move/checkout" },
    installandtosLoad: { pageName: "install tos and summary", detailPageName: "accord| install tos and summary - tos", events: "event5,event19,event65" },
    pfbandAutoPayLoad: { pageName: "info and credit", detailPageName: "accord| info and credit - autopay and pfb", events: "event5,event13,event14,scCheckout" },
    pfbContinue: { pageName: "info and credit", detailPageName: "accord| info and credit - pfb| primary email address", events: "event5,event13,event14,scCheckout" },
    pfbTos: { pageName: "info and credit", detailPageName: "accord| info and credit - pfb| tos", events: "event5,event13,event14,scCheckout" },
    depositLoad: { pageName: "install tos and summary", detailPageName: "accord| install tos and summary - deposit new", events: "event5,event19,event65" },
    tosLoad: { pageName: "install tos and summary", detailPageName: "accord| install tos and summary", events: "event5,event19,event65" },
    summaryInit: { pageName: "order confirmation", detailPageName: "accord| order confirmation| tech equip", events: "event5,event40,event42,event43,event44,event55,purchase", contentChannel: "/vz/residential/order/prospect accord/confirmation" },
    quickcheckoutsummaryInit: { pageName: "order confirmation", detailPageName: "accord| order confirmation| tech equip", events: "event5,event40,event42,event43,event44,event55,purchase", contentChannel: "/vz/residential/order/prospect accord/confirmation" },
    summaryInitSupp: { pageName: "accord supp| order confirmation", detailPageName: "fios| accord supp| order confirmation", events: "event5,event40,event42,event43,event44,event55,purchase", contentChannel: "/vz/residential/myverizon/whats+next/fios/acrd supp order" },
    lofLoad: { pageName: "order confirmation", detailPageName: "lof| olo registration offered ", events: "", contentChannel: "/vz/residential/order/prospect accord/confirmation" },
    initialInstallOptions: "",
    // buildFiosInit_Resume: { pageName: "fast pass resume", detailPageName: "byob - fast pass resume", contentChannel: "/vz/residential/order/prospect accord/fast pass", events: "event5,event90,event99,scOpen" },
    xpsEntryInit: { pageName: "smart cart resume entry", detailPageName: "smart cart resume entry| continue your cart", contentChannel: "/vz/residential/order/prospect accord/smart cart", events: "event5, event62", flowName: "prospect accord" },
    resave: { pageName: "smart cart resave", detailPageName: "smart cart resave", events: "event5,event22", contentChannel: "/vz/residential/order/prospect accord/smart cart", flowName: "prospect accord" },
    //accordionOpen_Resume: { pageName: "byob", detailPageName: "", events: "event5,event15,event20,event46",contentChannel: "/vz/residential/order/prospect accord/smart cart"},
    lboInit: { pageName: "lbo", detailPageName: "", events: "event5,event21", flowName: "prospect accord", contentChannel: "/vz/residential/order/prospect accord/error" },
    careFlowPageInit: { pageName: "affinity eligibility info", detailPageName: "affinity eligibility info", events: "event5", flowName: "prospect", contentChannel: "/vz/residential/order/affinity/" },
    entrypointInit: { pageName: "entrypoint", detailPageName: "entrypoint", events: "", flowName: "prospect", contentChannel: "" },
    seamlessMoves: { pageName: "seamless move landing", detailPageName: "seamless move landing", events: "event5,event9,event90,event99,scOpen,scAdd", contentChannel: "/vz/residential/order/prospect accord seamless move/lqresults" },
    checkoutMoves: { pageName: "info and credit", detailPageName: "accord| info and credit - billinfo", events: "event5,event13,event14,scAdd,scCheckout", contentChannel: "/vz/residential/order/prospect accord seamless move/checkout" },
    checkoutMovesNonSeamless: { pageName: "info and credit", detailPageName: "accord| info and credit - billinfo", events: "event5,event13,event14,scAdd,scCheckout", contentChannel: "/vz/residential/order/prospect accord move/checkout" },
    summaryMoves: { pageName: "order confirmation", detailPageName: "accord| order confirmation| tech equip", events: "event5,event40,event42,event43,event44,event55,purchase", contentChannel: "/vz/residential/order/prospect accord seamless move/confirmation" },
    buildFiosMoves: { pageName: "byob", detailPageName: "byob", contentChannel: "/vz/residential/order/prospect accord move/select", events: "event5,event90,event99,scOpen,scAdd" },
    nonSeamlessMoves: { pageName: "moves landing", detailPageName: "moves landing", events: "event5,event90,event99,scOpen,scAdd", contentChannel: "/vz/residential/order/prospect accord move/lqresults" },
    getOrderDetailInit: { pageName: "retrieve order info", detailPageName: "retrieve your order info", events: "event101", contentChannel: "" },
    buildFiosSupp: { pageName: "accord supp| my order", detailPageName: "fios| accord supp| my order", events: "event120,event179,event5,event90,event99,scOpen", contentChannel: "/vz/residential/myverizon/whats+next/fios/acrd supp order" },
    buildFiosInitEC: { pageName: "urc landing page", detailPageName: "ec| services overview| saved cart resume", contentChannel: "/vz/residential/order/accord reup service/care", events: "event5,event62" },
    upsellInit: { pageName: "byob", detailPageName: "byob| upsell| internet plan - 400 mbps to  gigabit connection", events: "event5,event15,event20,event46", flowName: "prospect accord" },
    // detailPageName: "tws disc| fios eligible"  changed CXTDT-603194
    buildTwsInit: { pageName: "tws discount", detailPageName: "tws discount eligible - fios", contentChannel: "/vz/residential/order/prospect accord/select", events: "event5", flowName: "prospect accord" },
    IntelPackLoad: { pageName: "byob", detailPageName: "byob", events: "event5,event15,event20,event46", contentChannel: "/vz/residential/order/prospect accord/select" },
    UseOwnRouterLoad: { pageName: "byob", detailPageName: "select your own router| byor", events: "event5,event15,event20,event46", contentChannel: "" },
    CallMoreCountries: { pageName: "byob", detailPageName: "call more countries", events: "event5,event15,event20,event46", contentChannel: "" },
    BussinessOverlay: { pageName: "lq address verification", detailPageName: "lq address verification - business addr ovrly", events: "event5, event8, event88", contentChannel: "" },
    pfbandAutoPayLoadReskin: { pageName: "checkout", detailPageName: "your billing preferences", events:"", flowName:""},
    mHauthentication  : { pageName: "authentication - tokenized email page", detailPageName: "verification link model", },
    seamlessMovesPerksOverlay: { pageName: "moves landing", detailPageName: "perk recommendations" },
    seamlessMovesPerksOverlayOSI: { pageName: "Order Summary Interstitial Page - Moves Flow", detailPageName: "perk recommendations" },
}

export const updateSCcustomEvent = (objName, eventName, updatedTags) => {

    if (scDataDetails[objName].pageName !== undefined && scDataDetails[objName].pageName !== "" && updatedTags.indexOf("pageName") === -1) {
        tempSCData.pageName = scDataDetails[objName].pageName
    }
    if (scDataDetails[objName].detailPageName !== undefined && scDataDetails[objName].detailPageName !== "" && updatedTags.indexOf("detailPageName") === -1) {
        tempSCData.detailPageName = scDataDetails[objName].detailPageName
    }
    if (scDataDetails[objName].events !== undefined && scDataDetails[objName].events !== "" && updatedTags.indexOf("events") === -1) {
        tempSCData.events = scDataDetails[objName].events
    }
    if (scDataDetails[objName].contentChannel !== undefined && scDataDetails[objName].contentChannel !== "" && updatedTags.indexOf("contentChannel") === -1) {
        tempSCData.contentChannel = scDataDetails[objName].contentChannel
    }
    if (scDataDetails[objName].flowName !== undefined && scDataDetails[objName].flowName !== "") {
        //VEC Ordering Tagging Issue in Chekcout
        let lqResponse = store && store.getState && store.getState().loopQual && store.getState().loopQual.lqResponse;
        if (lqResponse.hoaFlag === "Y" && scDataDetails[objName].flowName === "prospect accord") {
            tempSCData.flowName = "prospect accord| vvp";
        }
        else {
            tempSCData.flowName = scDataDetails[objName].flowName;
        }
    }
    if (objName == "BussinessOverlay") {
        let lqState = store && store.getState && store.getState().loopQual && store.getState().loopQual;
        tempSCData.servicePostalCode = lqState.selectedState.zip;
        tempSCData.serviceStateProvince = lqState.selectedState.state;
        tempSCData.statePostLQA = lqState.selectedState.state;
    }
    customEventUpdate(tempSCData, eventName, objName);
}

const customEventUpdate = (tempSCJSON, eventname, objName = "") => {
    try {
        let newEvent = {
            eventInfo: { eventName: eventname, type: "prospectOrdering", timeStamp: new Date(), processed: { adobeAnalytics: false } },
            page: { pageName: "", detailPageName: "", contentChannel: "", flowName: "", pageType: "" },
            cart: { productsSelected: "" },
            addrProfile: { servicePostalCode: "", productsQualified: "", maxSpeedQual: "", statePostLQA: "", serviceDMA: "", iontIndicator: "No" },
            transaction: { depositAmount: "", installOptions: "", MON: "", TwsTransactionID: "", UNID: "", Startdatetimestamp: "", Enddatetimestamp: "", Status: "", Vendor: "", TWSsegment: "", TWSsubgroup: "" },
            userProfile: { newRepeatXP1: "", affinityPartnerClassification: "", creditCheck: "", creditCheckstatus: "", depositAsked: "", depositPaid: "", prepaid: "N", customerCategory: "^New^", loginStatus: "" },
            product: [{
                productID: "",
                productNumber: "",
                primaryCategoryandSub: "",
                discountID: "",
                quantity: "",
                priceBase: "",
                priceShipping: "",
                priceTax: "",
                priceDiscount: "",
                priceRecurring: "",
                type: ""
            }],
            scEvents: ""
        };


        if (tempSCJSON.detailPageName !== "")
            newEvent.page.detailPageName = tempSCJSON.detailPageName
        if (tempSCJSON.pageName !== "")
            newEvent.page.pageName = tempSCJSON.pageName;
        if (tempSCJSON.contentChannel !== "")
            newEvent.page.contentChannel = tempSCJSON.contentChannel;
        if ((objName === "upsellInit" || objName === "addrVerification") && InHomeUtils.isFlowTypeCheckMoves()) {
            tempSCJSON.flowName = "prospect accord move";
        }
        else if (objName === "addrVerification" && !InHomeUtils.isFlowTypeCheckMoves()) {
            tempSCJSON.flowName = "prospect accord";
        }
        if (InHomeUtils.isNotNull(tempSCJSON.flowName) && !InHomeUtils.isFlowTypeCheckMoves()) {
            if (tempSCJSON.isMixMatch) {
                if (tempSCJSON.pageName.indexOf("smart cart") === -1 && tempSCJSON.flowName.indexOf("mix match") === -1) {//if not smart cart check for mix match if not add it
                    console.log("not smart cart and not mixmatch");
                    newEvent.page.flowName = tempSCJSON.flowName + "| mix match";
                }
                else if (tempSCJSON.pageName.indexOf("smart cart") !== -1 && tempSCJSON.flowName.indexOf("mix match") !== -1) {
                    console.log("smart cart and mixmatch");
                    newEvent.page.flowName = tempSCJSON.flowName.replace("| mix match", "");
                }
                else {
                    console.log("no change in flowname");
                    newEvent.page.flowName = tempSCJSON.flowName;
                }
            }
            else {
                console.log("is mixmatch false");
                newEvent.page.flowName = tempSCJSON.flowName.replace("| mix match", "");
            }

        }
        else {
            newEvent.page.flowName = tempSCJSON.flowName;
        }
        if (InHomeUtils.isFlowTypeCheckMoves()) {
            const moveExp_Cust = store && store.getState && store.getState().moveExp && store.getState().moveExp.cust_opt;
            const lqStateFCPFlow = store && store.getState && store.getState().loopQual && store.getState().loopQual.isFCPflow;
            if ((InHomeUtils.isNotNull(moveExp_Cust) && moveExp_Cust === "SEAMLESS") || (window.location.href.indexOf('moves/landing') > -1 && (objName === "faq" || objName === "seamlessMoves"))) {
                newEvent.page.flowName = "prospect accord seamless move";
            }
            else {
                newEvent.page.flowName = "prospect accord move";
            }
            if ((InHomeUtils.isNotNull(lqStateFCPFlow) && lqStateFCPFlow)) {
                newEvent.page.flowName = newEvent.page.flowName + "| mix match";
            }
        }
        if (tempSCJSON.UNID !== "")
            newEvent.transaction.UNID = tempSCJSON.UNID;
        if (tempSCJSON.Startdatetimestamp !== "")
            newEvent.transaction.Startdatetimestamp = tempSCJSON.Startdatetimestamp;
        if (tempSCJSON.Enddatetimestamp !== "")
            newEvent.transaction.Enddatetimestamp = tempSCJSON.Enddatetimestamp;
        if (tempSCJSON.Status !== "")
            newEvent.transaction.Status = tempSCJSON.Status;
        if (tempSCJSON.Vendor !== "")
            newEvent.transaction.Vendor = tempSCJSON.Vendor;
        if (tempSCJSON.TWSsegment !== "")
            newEvent.transaction.TWSsegment = tempSCJSON.TWSsegment;
        if (tempSCJSON.TWSsubgroup !== "")
            newEvent.transaction.TWSsubgroup = tempSCJSON.TWSsubgroup;
        if (tempSCJSON.servicePostalCode !== "")
            newEvent.addrProfile.servicePostalCode = tempSCJSON.servicePostalCode;
        if (tempSCJSON.productsQualified !== "")
            newEvent.addrProfile.productsQualified = tempSCJSON.productsQualified;
        if (tempSCJSON.addressID !== "")
            newEvent.addrProfile.addressID = tempSCJSON.addressID;
        if (tempSCJSON.serviceStateProvince !== "")
            newEvent.addrProfile.serviceStateProvince = tempSCJSON.serviceStateProvince;
        if (tempSCJSON.vzwCustomerIdentifier !== "")
            newEvent.addrProfile.vzwCustomerIdentifier = tempSCJSON.vzwCustomerIdentifier;
        if (tempSCJSON.maxSpeedQual !== "")
            newEvent.addrProfile.maxSpeedQual = tempSCJSON.maxSpeedQual;
        if (tempSCJSON.statePostLQA !== "")
            newEvent.addrProfile.statePostLQA = tempSCJSON.statePostLQA;
        if (tempSCJSON.serviceDMA !== "")
            newEvent.addrProfile.serviceDMA = tempSCJSON.serviceDMA;
        if (tempSCJSON.newRepeatXP1 !== "")
            newEvent.userProfile.newRepeatXP1 = tempSCJSON.newRepeatXP1;
        if (tempSCJSON.detailPageName.indexOf("crd chk") > -1 && tempSCJSON.creditCheck !== "" && tempSCJSON.creditCheckstatus !== "") {
            newEvent.userProfile.creditCheck = tempSCJSON.creditCheck;
            newEvent.userProfile.creditCheckstatus = tempSCJSON.creditCheckstatus;
        }
        else {
            newEvent.userProfile.creditCheck = newEvent.userProfile.creditCheckstatus = "";
        }
        if (tempSCJSON.depositAsked !== "")
            newEvent.userProfile.depositAsked = tempSCJSON.depositAsked;
        if (tempSCJSON.depositPaid !== "")
            newEvent.userProfile.depositPaid = tempSCJSON.depositPaid;
        if (tempSCJSON.affinityPartnerClassification !== "")
            newEvent.userProfile.affinityPartnerClassification = tempSCJSON.affinityPartnerClassification;
        if (tempSCJSON.customerCategory !== "")
            newEvent.userProfile.customerCategory = tempSCJSON.customerCategory;
        if (tempSCJSON.bundleSelected !== "")
            newEvent.cart.productsSelected = tempSCJSON.bundleSelected;
        if (tempSCJSON.events !== "")
            newEvent.scEvents = tempSCJSON.events;
        if (tempSCJSON.detailPageName.indexOf("lof") > -1) {
            newEvent.scEvents = ""
        }
        if (tempSCJSON.depositAmount !== "")
            newEvent.transaction.depositAmount = tempSCJSON.depositAmount;
        if (tempSCJSON.installOptions !== "")
            newEvent.transaction.installOptions = tempSCJSON.installOptions;
        if (tempSCJSON.MON !== "")
            newEvent.transaction.MON = tempSCJSON.MON;
        if (tempSCJSON.product !== null)
            newEvent.product = tempSCJSON.product;

        if (tempSCJSON.IONTEligible)
            newEvent.addrProfile.iontIndicator = "Yes";

        if (tempSCJSON.isSUPPflow) {
            newEvent.userProfile.loginStatus = "res logged in";
            newEvent.page.pageType = "supp order";
        }

        window.digitalData = window.digitalData || {};
        window.digitalData.events = window.digitalData.events || [];
        window.digitalData.events.push(newEvent);
        sendCustomEvent(eventname);
    }
    catch (err) {
        console.log(err);
    }

}

const sendCustomEvent = (evt) => {
    retrySendCustomEventCount = 0;
    if (window.dtm_doplugins) {
        if (document.createEvent && document.body.dispatchEvent) {
            var event = document.createEvent('Event');
            event.initEvent(evt, true, true);
            document.body.dispatchEvent(event);
        } else if (window.CustomEvent && document.body.dispatchEvent) {
            var ev = new CustomEvent(evt, {
                bubbles: true,
                cancelable: true
            });
            document.body.dispatchEvent(ev);
        }
    }
    else {
        setTimeout(() => { retrySendCustomEvent(evt); }, 500);
    }
}

const retrySendCustomEvent = (evt) => {
    retrySendCustomEventCount = retrySendCustomEventCount++;
    if (window.dtm_doplugins) {
        sendCustomEvent(evt);
    } else if (retrySendCustomEventCount < 5) {
        setTimeout(() => { retrySendCustomEvent(evt); }, 500);
    }
}

export const updateSCTags = (linkName, message='', detail= '') => {
    try {
        const isvzfwFlag = store && store.getState() && store.getState().buildProduct && store.getState().buildProduct?.isVZFwdFlag;
        if (linkName !== ""  && vzdl && vzdl.page && vzdl.page.name) {
            vzdl.target.message = "";
            if(message !== ''){
                vzdl.target.message = message
            }
            if(isvzfwFlag){
                vzdl.target.message = vzdl.target?.message?.length > 0 ? "" :  vzdl.target.message
                vzdl.page.contentFragments = vzdl.page.contentFragments?.length > 0 ? "" :  vzdl.page.contentFragments;
            }
            if(detail!== '') {
                vzdl.page.detail = detail
            }
            window.scLinkTrackID && window.scLinkTrackID(linkName);
        }
    } catch (ex) {
        console.log("updateSCTags" + ex.message);
        catchJSException('DTMScript', "visitId", 'updateSCTags', "updateSCTags : " + ex);
    }
}

// This is sitecatalyst function- added temporary for testing locally
// const scLinkTrackID = (linkName) =>{    
//     try
//     {
//         window.digitalData.page = window.digitalData.page || [];
//         window.digitalData.page.linkName = linkName;

//         console.log(JSON.stringify(window.digitalData))
//     }
//     catch (err) {
//         console.log(err);
//     }    

// }

const getBundlecategory = (orderDetail) => {
    let srvcs = InHomeUtils.isNotNull(orderDetail.servicesOrdered) ? orderDetail.servicesOrdered.split(',') : "";
    let val = ""
    if (srvcs.length === 3) {
        val = "FVTB+FVIT+";
    }
    else if (InHomeUtils.isNotNull(orderDetail.servicesOrdered)) {
        if (orderDetail.servicesOrdered.indexOf("DATA") > -1 && orderDetail.servicesOrdered.indexOf("VIDEO") > -1) {
            val = "DFLX+FITN+"
        }
        else if (orderDetail.servicesOrdered.indexOf("DATA") > -1 && orderDetail.servicesOrdered.indexOf("FIOS_VOICE") > -1) {
            val = "FVDD+FVDN+"
        }
        else if (orderDetail.servicesOrdered.indexOf("VIDEO") > -1 && orderDetail.servicesOrdered.indexOf("FIOS_VOICE") > -1) {
            val = "FVTB+FVTN+"
        }
    }

    return val;
}

const getPrdArrayFromCart = (obj, flowType) => {
    return ({
        "productID": getPrdid(obj, flowType),
        "discountID": "",
        "productNumber": (obj.prodName.indexOf("agreement") > -1 || obj.prodName.indexOf("contract") > -1) ? "0" : obj.prodId,
        "primaryCategoryandSub": (obj.prodName.indexOf("agreement") > -1 || obj.prodName.indexOf("contract") > -1) ? "AGREEMENT" :
            ((obj.prodTypeVal === "RSN") ? obj.prodType : prdCategoryInfo(obj.prodType, flowType, obj)),
        "priceBase": obj.prodType === "MRCFEE" ? obj.bundleActucalPrice : (obj.price === "Included" ? "0" : (obj.price !== null ? obj.price.replace("$", "") : "0")),
        "priceRecurring": obj.priceType !== null ? (obj.priceType === "NRC" ? "0" : (obj.price === "Included" ? "0" : obj.price.replace("$", ""))) : "0",
        "priceDiscount": "0",
        "quantity": "1",
    })

}

const getPrdid = (obj, flowType) => {
    let prdId = obj.prodName === "" ? obj.prodId : obj.prodName.replace(/&reg;/g, "").replace(/&amp;/g, "and");

    if (prdId === "DVR") {
        prdId = "DVR Service";
    }
    if (InHomeUtils.isNotNull(obj.prodTypeVal) && obj.prodTypeVal.indexOf("CUSTOM") > -1 && prdId.indexOf("Custom TV") === -1 && obj.prodTypeVal.indexOf("CUSTOMER_PROVIDED") === -1) {
        prdId = "Custom TV " + prdId;
    }

    if (flowType === "SUPP" && tempSCData.profileProduct.length > 0) {
        let isprofileprdMatch = false;
        for (var i = 0; i < tempSCData.profileProduct.length; i++) {
            if (tempSCData.profileProduct[i].prodId === obj.prodId) {
                isprofileprdMatch = true;
                break;
            }
        }
        if (!isprofileprdMatch) {
            tempSCData.profileProduct.map((tmpprofileObj) => {
                if (obj.prodId !== tmpprofileObj.prodId && obj.prodType === tmpprofileObj.prodType) {
                    switch (obj.prodType) {
                        case "BASIC":
                        case "VROOM":
                        case "VFEATURE":
                            prdId = "FVDO+ supp added-" + prdId + " FVDO+ supp deleted-" + tmpprofileObj.prodName;
                            break;
                        case "FTTPD":
                            prdId = "FTTP+ supp added-" + prdId + " FTTP+ supp deleted-" + tmpprofileObj.prodName;
                            break;
                        default:
                            break;
                    }

                }
                else if (obj.prodId !== tmpprofileObj.prodId && InHomeUtils.isNotNull(obj.prodType) && obj.prodType.indexOf("ROUTER") > -1
                    && InHomeUtils.isNotNull(tmpprofileObj.prodType) && tmpprofileObj.prodType.indexOf("ROUTER") > -1 && obj.prodType !== tmpprofileObj.prodType) {
                    prdId = "supp change router " + tmpprofileObj.prodName + " to supp " + prdId;
                }

            });
        }
    }

    if (flowType === "SUPP" && obj.prodType === "PREMIUM")
        prdId = "FVDO+ supp added- " + prdId;

    return prdId;
}

export const getProductObject = (orderDetail, tierPricing, flowType) => {
    let prdArray = []
    try {

        if (flowType != 'AF') {
            // Currently for Bundle Recurring and Base Price is same as we dont have seperate baseprice in cart JSON. Need to check further from service level - Added code need to deploy
            if (orderDetail.bundle && InHomeUtils.isNotNull(orderDetail.bundleId) && orderDetail.bundleId !== "B0038") {
                prdArray.push({
                    "productID": tierPricing.tierContent[0].sections.section[0].subSections.subSection[0].title,
                    "discountID": "",
                    "productNumber": orderDetail.bundleId,
                    "primaryCategoryandSub": getBundlecategory(orderDetail), // Currently no Seperatedetails for bundle from JSON.. need to check with Service Team,
                    "priceBase": InHomeUtils.isNotNull(tierPricing.tierContent[0].sections.section[0].subSections.subSection[0].priceWithoutPromos) ? parseFloat(tierPricing.tierContent[0].sections.section[0].subSections.subSection[0].priceWithoutPromos.replace("$", "")).toFixed(2) : InHomeUtils.isNotNull(tierPricing.tierContent[0].sections.section[0].subSections.subSection[0].sectionTotalprice) ? tierPricing.tierContent[0].sections.section[0].subSections.subSection[0].sectionTotalprice.replace("$", "") : "0.00",
                    "quantity": "1",
                    "priceRecurring": InHomeUtils.isNotNull(tierPricing.tierContent[0].sections.section[0].subSections.subSection[0].sectionTotalprice) ? tierPricing.tierContent[0].sections.section[0].subSections.subSection[0].sectionTotalprice.replace("$", "") : "0.00",
                    "priceDiscount": "0"
                });
            }

            //Currently no seperation for BasePrice and DiscountedPrice - need to check with service and update accordingly - added code need to deploy
            if (tierPricing.tierContent[0].sections && tierPricing.tierContent[0].sections.section[0] && tierPricing.tierContent[0].sections.section[0].subSections !== undefined) {
                tierPricing.tierContent[0].sections.section[0].subSections.subSection[0].products.map(obj => {
                    if (obj.prodTypeVal !== "FDVADMIN") {
                        prdArray.push(getPrdArrayFromCart(obj, flowType))
                    }
                })
            }

            //Look for other Products like Channel/Equipment/Vroom etc..

            tierPricing.tierContent[0].sections.section.map(secObj => {
                if (secObj.sectionName === "Equipment") {
                    secObj.subSections.subSection.map(subSecObj => {
                        if (subSecObj.sectionType === "ROUTER" || subSecObj.sectionType === "SETUPBOX" || subSecObj.sectionType === "RECORDING" || subSecObj.sectionType === "DIGITALADAPTOR") {
                            subSecObj.products.map(obj => {
                                prdArray.push(getPrdArrayFromCart(obj, flowType))
                            })
                        }
                    })
                }
                if (secObj.sectionName === "Service") {
                    secObj.subSections.subSection.map(subSecObj => {
                        if (subSecObj.sectionType === "CHANNEL" || subSecObj.sectionType === "LISTING" || subSecObj.sectionType === "VASSTANDALONE" || subSecObj.sectionType === "STREAMINGSERVICES") {
                            subSecObj.products.map(obj => {
                                prdArray.push(getPrdArrayFromCart(obj, flowType))
                            })
                        }
                        if (subSecObj.sectionType === "TVSTANDALONE") {
                            subSecObj.products.map(obj => {
                                if (obj.prodType === "BASIC_FF") {
                                    prdArray.push(getPrdArrayFromCart(obj, flowType))
                                }
                            })
                        }
                        if (subSecObj.sectionType === "INTLPACKAGE") {
                            subSecObj.products.map(obj => {
                                if (obj.prodType === "INTLPREMIUM") {
                                    prdArray.push(getPrdArrayFromCart(obj, flowType))
                                }
                            })
                        }
                    })
                }

                if (secObj.sectionName === "Onetimecharges") {
                    secObj.subSections.subSection.map(subSecObj => {
                        if (subSecObj.sectionType === "BATTERYBACKUP" || subSecObj.sectionType === "ROUTERBUY" || subSecObj.sectionType === "VASSTANDALONE" || subSecObj.sectionType === "SETUPFEE") {
                            subSecObj.products.map(obj => {
                                prdArray.push(getPrdArrayFromCart(obj, flowType));
                            })
                        }

                    })
                }

                if (secObj.sectionName === "Promotions") {
                    secObj.subSections.subSection.map(subSecObj => {
                        return (subSecObj.promos.map(obj => {
                            prdArray.push({
                                "productID": InHomeUtils.isNotEmpty(obj.promoText) && obj.promoText.indexOf('Eligible Customer') > -1 && obj.promoText.indexOf('Mobile + Home Rewards') > -1 ? 'Mobile + Home Rewards Eligible' : obj.promoText,
                                "discountID": obj.promoText,
                                "productNumber": obj.promoId,
                                "primaryCategoryandSub": "DISCOUNT",//obj.offerAttrValue,
                                "priceDiscount": InHomeUtils.isNotNull(obj.price) ? obj.price : "0",
                                "priceRecurring": "0",
                                "priceBase": "0",
                                "type": obj.offerAttr,
                                "quantity": "1",
                            })
                        }))
                    })
                }

            })

        }
        else if (flowType === 'AF') {

            var cartProducts = tierPricing.tierContent;

            if (cartProducts != null && cartProducts.length > 0 && cartProducts[0].sections != null && cartProducts[0].sections.section != null) {
                let bundleProd = new Object();
                if (orderDetail.bundle == true) {
                    bundleProd.productNumber = orderDetail.bundleId;
                }

                cartProducts[0].sections.section.map((cartsections, index) => {
                    if (cartsections != null && cartsections.subSections != null && cartsections.subSections.subSection != null) {
                        cartsections.subSections.subSection.map((cartsubsection, index) => {
                            if (cartsubsection != null) {
                                if (orderDetail != null && orderDetail.bundle == true && cartsubsection.sectionType == 'SVCCOMPONENT') {
                                    bundleProd.productID = cartsubsection.title;
                                    bundleProd.primaryCategoryandSub = cartsubsection.sectionType;
                                    bundleProd.quantity = "1";
                                    bundleProd.priceDiscount = "0";
                                    bundleProd.priceRecurring = cartsubsection.sectionTotalprice;
                                    bundleProd.priceBase = cartsubsection.sectionTotalprice;
                                    bundleProd.type = cartsubsection.sectionType;
                                    prdArray.push(bundleProd);
                                }

                                if (cartsubsection.products != null) {
                                    cartsubsection.products.map((value, index) => {
                                        if (value.prodName != null) {
                                            let prod = new Object();
                                            if (value.prodType == "FVPRIMARY") {
                                                prod.productID = value.prodName.replace(/[^A-Za-z ]+/g, '');
                                            }
                                            else {
                                                prod.productID = value.prodName;
                                            }
                                            prod.productNumber = value.prodId;
                                            prod.primaryCategoryandSub = value.prodType;
                                            prod.quantity = "1";
                                            prod.priceDiscount = "0";
                                            if (value.priceType == "NRC") {
                                                prod.priceNonRecurring = value.price;
                                            } else {
                                                prod.priceRecurring = value.price;
                                            }
                                            prod.priceBase = value.price;
                                            prod.type = value.prodType;
                                            prod.priceType = value.priceType;
                                            UpdateContractforRenewal(prod);
                                            prdArray.push(prod);
                                        }
                                    });
                                }

                                if (cartsubsection.promos != null) {
                                    cartsubsection.promos.map((value, index) => {
                                        let prod = new Object();
                                        prod.productID = value.promoText;
                                        prod.productNumber = value.promoId;
                                        prod.primaryCategoryandSub = value.offerAttrValue;
                                        prod.quantity = "1";
                                        if (value.price != null)
                                            prod.priceDiscount = value.price;
                                        else
                                            prod.priceDiscount = "0"
                                        prod.priceRecurring = "0";
                                        prod.priceBase = "0";
                                        prod.type = value.offerAttr;
                                        prdArray.push(prod);
                                    });
                                }
                                if (cartsubsection.promotions != null) {
                                    cartsubsection.promotions.map((value, index) => {
                                        if (value.OfferAttr && value.OfferAttr != "|NOTFORBACKEND|") {
                                            var prod = new Object();
                                            prod.productID = value.name;
                                            prod.productNumber = value.id;
                                            prod.primaryCategoryandSub = value.prodType;
                                            prod.quantity = "1";
                                            if (value.price != null)
                                                prod.priceDiscount = value.price;
                                            else
                                                prod.priceDiscount = "0"
                                            prod.priceRecurring = "0";
                                            prod.priceBase = "0";
                                            prod.type = value.OfferAttr;
                                            if (value.promotionId != null)
                                                prod.promoID = value.promotionId;
                                            if (value.offerId != null)
                                                prod.offerID = value.offerId;
                                            prdArray.push(prod);
                                        }
                                    });
                                }
                            }
                        });
                    }
                });

            }
        }
    }

    catch (error) {
        console.log(error)
    }

    return prdArray;
}

const getprdCategoryInfoSupp = (tmpprodType, prdobj) => {
    let val = tmpprodType;

    if (tempSCData.profileProduct.length > 0) {
        let isprofileprdMatch = false;
        for (var i = 0; i < tempSCData.profileProduct.length; i++) {
            if (tempSCData.profileProduct[i].prodId === prdobj.prodId) {
                isprofileprdMatch = true;
                break;
            }
        }
        if (!isprofileprdMatch) {
            tempSCData.profileProduct.map((tmpprofileObj) => {
                if (prdobj.prodId !== tmpprofileObj.prodId && prdobj.prodType === tmpprofileObj.prodType) {
                    switch (prdobj.prodType) {
                        case "BASIC":
                            val = "Supp TV Change " + tmpprofileObj.prodName + "to " + prdobj.prodName;
                            break;
                        case "FTTPD":
                            val = "Supp INET Change " + tmpprofileObj.prodName + "to " + prdobj.prodName;
                            break;
                        case "VROOM":
                        case "VFEATURE":
                            val = "supp add FTV Equip";
                            break;

                        default:
                            break;
                    }

                }
            });
        }
    }

    return val;
}

const prdCategoryInfo = (prodType, flowType, prdobj) => {
    let val = prodType;
    switch (prodType) {
        case 'FTTPD':
            val = "FTTP+DYAC+";
            break;
        case 'BASIC':
            val = "FVDO+CPKG+";
            break;
        case 'FVPRIMARY':
            val = "FVC+NATL+";
            break;
        case 'ROUTERBILLER':
        case 'ROUTERNRCBILLER':
            val = "FCPE+" + prodType;
            break;
        case 'VROOM':
        case 'VFEATURE':
            val = "FVDO+" + prodType;
            break;
        case 'PREMIUM':
            val = "FVDO+APKG+MOVI";
            break;
        case 'FVLISTMAIN':
            val = "FVC+LT1+";
            break;
        case 'FVNONPUB':
            val = "FVC+NP";
            break;
        case 'SLABATTERY':
        case 'DCELLTRAY':
            val = "FVC+BTRY";
            break;
        case 'MRCFEE':
            val = "FVDO+MRCFEE+BROADCAST";
            break;
        default:
            break;
    }

    if (flowType === "SUPP") {
        val = getprdCategoryInfoSupp(val, prdobj)
    }


    return val;
}

const getPrdName = (product, flowType) => {
    let val = product.name && product.name === "DVR" ? "DVR Service" : product.name && product.name.replace(/&amp;/g, "and");

    if (product.prodType.indexOf("ROUTER") > -1) {
        if (product.prodTypeValue.indexOf("CUSTOMER_PROVIDED") > -1)
            val = "Customer Provided Router";
        else {
            val = (product.prodType.indexOf("NRC") > -1 ? "Buy " : "") + "Fios Quantum Gateway Router";
        }

    }
    else {
        if (product.prodType === "FVNONPUB") {
            val = "Non Published Service";
        }
        else if (product.prodType === "FVLISTMAIN") {
            val = "Listed and Published";
        }
        else if (product.prodType === "BASIC") {
            val = "Custom TV " + val;
        }
        else if (product.prodType === Service.streamDevCount) {
            val = product.OriginalName;
        }
        else if (product.prodType === 'SPLOFFER') {
            let isOfferPrepaid = false;
            if (product.OfferText && product.OfferText.indexOf("Visa Prepaid Card") > -1) {
                val = product.OfferText.replace("Visa Prepaid Card", "Prepaid Reward Card");
                isOfferPrepaid = true;
            }
            if (product.offerFor && product.offerFor.toLowerCase() === "data" && product.OfferText.indexOf("Internet offer") === -1) {
                if (isOfferPrepaid) {
                    val = "Internet offer: " + val;
                } else {
                    val = "Internet offer: " + product.OfferText;
                }
            } else {
                val = product.OfferText;
            }
        }
    }

    if (flowType === "SUPP") {
        if (tempSCData.profileProduct.length > 0) {
            let isprofileprdMatch = false;
            for (var i = 0; i < tempSCData.profileProduct.length; i++) {
                if (tempSCData.profileProduct[i].prodId === product.id) {
                    isprofileprdMatch = true;
                    break;
                }
            }
            if (!isprofileprdMatch) {
                tempSCData.profileProduct.map((tmpprofileObj) => {
                    if (product.id !== tmpprofileObj.prodId && product.prodType === tmpprofileObj.prodType) {
                        if (product.prodType === "VROOM" || product.prodType === "VFEATURE") {
                            val = "FVDO+ supp added-" + val + " FVDO+ supp deleted-" + tmpprofileObj.prodName;
                        }

                    }
                    else if (product.id !== tmpprofileObj.prodId && InHomeUtils.isNotNull(product.prodType) && product.prodType.indexOf("ROUTER") > -1
                        && InHomeUtils.isNotNull(tmpprofileObj.prodType) && tmpprofileObj.prodType.indexOf("ROUTER") > -1 && product.prodType !== tmpprofileObj.prodType) {
                        //console.log("router changed");
                        val = "supp change router " + tmpprofileObj.prodName + " to supp " + val;
                    }
                });
            }
        }
    }

    return val;
}

const getVasCategory = (product) => {
    let val = product.prodType;

    if (product.bundleId !== null)
        val = "VAS+VSBN+FIXD";
    else
        val = "VAS+VSIT+XXXX";

    return val;
}

export const addToCartSCEvent = (visitId, product, prodType, response, isDoFlow, isPrdAddEvent, upsellInfo = null, flowType, isFCPflow, cloudStatus, eventAction = null) => {
    try {
        let displayFullcartData = false;
        let val = ""
        let lqResponse = store && store.getState && store.getState().loopQual && store.getState().loopQual.lqResponse;
        if (flowType == "15G") {
            tempSCData.events = (InHomeUtils.isNotNull(eventAction) && eventAction == "AddtoCart" ? "scOpen, scAdd" : "scRemove");
        } else {
            tempSCData.events = (InHomeUtils.isNotNull(eventAction) && eventAction == "AddtoCart" ? "scAdd" : "scRemove");
        }
        if (prodType === Service.internet || prodType === Service.tv || prodType === Service.voice) {
            displayFullcartData = true;
        }
        if (InHomeUtils.isNotNull(upsellInfo) && upsellInfo.isUpsell) {
            tempSCData.pageName = "byob";
            tempSCData.detailPageName = upsellInfo.upsellSCTag;
        }
        else {
            val = isDoFlow ? "do accord" : "byob"
            tempSCData.pageName = val;
            if (prodType === Service.internet) {
                val = val + "| internet"
            }
            else if (prodType === Service.techSure && InHomeUtils.isNotNull(cloudStatus) && cloudStatus) {
                val = val + "| internet| Add Cloud Storage";
            }
            else if (prodType === Service.tv || prodType === Service.customTV) {
                val = val + "| tv"
                if (product.prodTypeValue === "Fios_Five") {
                    val = val + "| your fios tv";
                }
            }
            else if (prodType === Service.voice) {
                val = val + "| phone"
            }
            else if (prodType === Service.router) {
                val = val + "| internet| customize"
                if (product.prodTypeValue === "CUSTOMER_PROVIDED_ROUTER") {
                    val = val.replace("customize", "select your own router");
                }
            }
            else if (prodType === Service.techSure) {
                val = val + "| internet| security and protection";
            }
            else if (prodType === Service.recording || prodType === Service.vRoom || prodType === Service.channel) {
                val = val + "| tv| customize"
            }
            else if (prodType === "WINBACKADDED") {
                val = val + "| phone| winback| current phone number " + (isPrdAddEvent ? "selected" : "removed");
                displayFullcartData = true;
            }
            else if (prodType === Service.listing) {
                val = val + "| phone| directory listing"
            }
            else if (prodType === Service.battery) {
                val = val + "| phone| battery backup"
            }
            else if (prodType === Service.streamServ) {
                val = val + "| stream services-devices| pick service"
            }
            else if (prodType === Service.streamDev) {
                val = val + "| stream services-devices| add device"
            }
            else if (prodType === Service.streamDevCount) {
                val = val + "| stream services-devices| add devices-nums"
            }
            else if (prodType === Service.flashOffer) {
                val = val + "| internet| black friday"
            }
            else if (prodType === Service.intrnlChnl) {
                val = val + "| tv| add international channel"
            }
            // else if (prodType === ""){

            // }
            else if (prodType === Service.splOffer) {
                // if (InHomeUtils.isNotNull(product)  && ((InHomeUtils.isNotNull(product.BsOfferAttrValue)  && product.BsOfferAttrValue === "DISCOVERYPLUS_3MO")
                //      || (InHomeUtils.isNotNull(product.offerAttrValue)  && product.offerAttrValue === "DISCOVERYPLUS_3MO"))) {
                //     val = val + "| internet| select offer| discovery plus details ovrly| 3m";
                // }
                // else if (InHomeUtils.isNotNull(product)  && ((InHomeUtils.isNotNull(product.BsOfferAttrValue)  && product.BsOfferAttrValue === "DISCOVERYPLUS_6MO")
                // || (InHomeUtils.isNotNull(product.offerAttrValue)  && product.offerAttrValue === "DISCOVERYPLUS_6MO"))) {
                //     val = val + "| internet| select offer| discovery plus details ovrly| 6m";
                // }
                // else if (InHomeUtils.isNotNull(product)  && ((InHomeUtils.isNotNull(product.BsOfferAttrValue)  && product.BsOfferAttrValue === "DISCOVERYPLUS_12MO")
                // || (InHomeUtils.isNotNull(product.offerAttrValue)  && product.offerAttrValue === "DISCOVERYPLUS_12MO"))) {
                //     val = val + "| internet| select offer| discovery plus details ovrly| 12m";
                // }
                // else if (InHomeUtils.isNotNull(product)  && ((InHomeUtils.isNotNull(product.BsOfferAttrValue)  && product.BsOfferAttrValue === "SONY_PLAYSTATION")
                // || (InHomeUtils.isNotNull(product.offerAttrValue)  && product.offerAttrValue === "SONY_PLAYSTATION"))) {
                //     val = val + "| internet| select offer| play station details ovrly";
                // }
                // else if (InHomeUtils.isNotNull(product)  && ((InHomeUtils.isNotNull(product.BsOfferAttrValue)  && product.BsOfferAttrValue === "SONY_PLAYSTATION_3MONTH")
                // || (InHomeUtils.isNotNull(product.offerAttrValue)  && product.offerAttrValue === "SONY_PLAYSTATION_3MONTH"))) {
                //     val = val + "| internet| select offer| play station details ovrly";
                // }
                // else{
                val = val + "| internet| select your int promo offer";
                // } 
            }
            tempSCData.detailPageName = val // for DOflows/Prepaid need to uodate these values later 
        }

        let srvcsOrdered = (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.orderDetail) && InHomeUtils.isNotNull(response.data.orderDetail.servicesOrdered)) ? response.data.orderDetail.servicesOrdered.replace("DATA", "fdata").replace("VIDEO", "ftv").replace("FIOS_VOICE", "fphone") : "";
        let prdArray = []
        let srvcsVal = ""
        if (srvcsOrdered !== "") {
            let srvcs = srvcsOrdered.split(',');
            if (srvcs.length === 3) {
                srvcsVal = "triple - "
            }
            else if (srvcs.length === 2) {
                srvcsVal = "double - "
            }
            else {
                srvcsVal = "single - "
            }
            srvcsVal = srvcsVal + srvcsOrdered.replace(/,/g, "+");
        }

        if (prodType !== "INITCHECKOUTDATA") {
            tempSCData.bundleSelected = srvcsVal;
        }
        if (InHomeUtils.isNotNull(upsellInfo) && upsellInfo.isUpsell) {
            upsellInfo.upsellProducts.map(product => {
                prdArray.push({
                    "productID": product.name,
                    "discountID": "",
                    "productNumber": product.id,
                    "primaryCategoryandSub": product.prodType === "PPP" ? getVasCategory(product) : prdCategoryInfo(product.prodType, flowType, product),
                    "priceBase": calcprdBasePrice(product),
                    "priceDiscount": "0",
                    "quantity": "1",
                    "priceRecurring": InHomeUtils.isNotNull(product.displayPrice) ? product.displayPrice.replace("$", "") : "0"
                });
                return prdArray;
            })
        }
        else {
            if (prodType === Service.channel) {
                response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.subSection.map(obj => {
                    if (obj.sectionType === "CHANNEL") { // This is premium pack addition to DTM Tag 
                        prdArray.push({
                            "productID": (flowType === "SUPP" ? "FVDO+ supp added-" : "") + product.name.replace(/&reg;/g, ""),
                            "discountID": "",
                            "productNumber": product.id, // Currently dont have USOC in cart response .. Need to change in service level
                            "primaryCategoryandSub": prdCategoryInfo(product.prodType, flowType, product),//obj.title, // Currently dont have prodType  in cart response .. Need to change in service level
                            "priceBase": InHomeUtils.isNotNull(product.displayPrice) ? product.displayPrice.replace("$", "") : (InHomeUtils.isNotNull(product.originalPrice) ? product.originalPrice.replace("$", "") : "0"),
                            "priceRecurring": InHomeUtils.isNotNull(product.displayPrice) ? product.displayPrice.replace("$", "") : (InHomeUtils.isNotNull(product.originalPrice) ? product.originalPrice.replace("$", "") : "0"),
                            "quantity": "1",
                        });

                        prdArray.push({
                            "productID": (flowType === "SUPP" ? "FVDO+ supp added-" : "") + obj.title,
                            "discountID": "",
                            "productNumber": obj.chnlPackId, // Currently dont have USOC for premium pack in cart response .. Need to change in service level                        
                            "priceBase": InHomeUtils.isNotNull(obj.sectionTotalprice) ? obj.sectionTotalprice.replace("$", "") : "0",
                            "priceRecurring": InHomeUtils.isNotNull(obj.sectionTotalprice) ? obj.sectionTotalprice.replace("$", "") : "0",
                            "quantity": "1",
                        });
                    }
                    return prdArray;
                })
            }
            else {
                if (displayFullcartData || !isPrdAddEvent) {
                    prdArray = getProductObject(response.data.orderDetail, response.data.cartTierPricing, flowType)
                }
                else if (InHomeUtils.isNotNull(product)) {
                    if (prodType === Service.flashOffer) {
                        prdArray.push({
                            "productID": product.OfferText,
                            "discountID": product.OfferText,
                            "productNumber": product.id,
                            "primaryCategoryandSub": "DISCOUNT",//product.offerAttrValue,
                            "priceDiscount": "0",
                            "priceRecurring": "0",
                            "priceBase": "0",
                            "type": product.BsOfferAttr,
                            "quantity": "1",
                        })
                    }
                    else {
                        let priceNonRecurring;
                        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data)
                            && InHomeUtils.isNotNull(response.data.cartTierPricing)
                            && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0])
                            && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].totalNrcPrice)) {
                            priceNonRecurring = response.data.cartTierPricing.tierContent[0].totalNrcPrice;
                        }
                        if (InHomeUtils.isNull(priceNonRecurring) && InHomeUtils.isNotNull(response) &&
                            InHomeUtils.isNotNull(response.tierContent[0]) && InHomeUtils.isNotNull(response.tierContent[0].totalNrcPrice)) {
                            priceNonRecurring = response.tierContent[0].totalNrcPrice;
                        }
                        prdArray.push({
                            "productID": getPrdName(product, flowType),
                            "discountID": "",
                            "productNumber": product.id,
                            "primaryCategoryandSub": product.prodType === "PPP" ? getVasCategory(product) : prdCategoryInfo(product.prodType, flowType, product),
                            "priceBase": calcprdBasePrice(product),
                            // "priceBase": response.data.cartTierPricing.tierContent[0].totalNrcPrice,
                            "priceNonRecurring": InHomeUtils.isNotNull(priceNonRecurring) ? priceNonRecurring.replace("$", "") : '0',
                            "priceDiscount": "0",
                            "quantity": (InHomeUtils.isNotNull(product.prodType) && product.prodType === Service.streamDevCount) ? product.unitCount : "1",
                            //"priceNonRecurring": product.priceType === "NRC" ? (product.displayPrice !== null ? product.displayPrice.replace("$", "") : (product.originalPrice.replace("$", "") !== null ? product.originalPrice.replace("$", "") : "0")) : "0",
                            "priceRecurring": ((InHomeUtils.isNotNull(product.prodType) && product.prodType.indexOf("NRC") > -1) || (InHomeUtils.isNotNull(product.keyword) && product.keyword.indexOf("FDV_BTRY_CHARGED") > -1)) ? "0" : calcprdBasePrice(product)
                        });
                    }
                }
            }
        }


        tempSCData.product = prdArray;

        if (flowType === "MV" || InHomeUtils.isFlowTypeCheckMoves()) {
            tempSCData.contentChannel = "/vz/residential/order/prospect accord move/select";
            if (InHomeUtils.isNotNull(isFCPflow) && isFCPflow && !InHomeUtils.flowCheckforSeamless() && !InHomeUtils.isFCPInProfile()) {
                if (lqResponse.hoaFlag === "Y") {
                    tempSCData.flowName = "prospect accord move| mix match| vvp";
                }
                else {
                    tempSCData.flowName = "prospect accord move| mix match";
                }
            }
            else if (InHomeUtils.isNotNull(isFCPflow) && isFCPflow && InHomeUtils.flowCheckforSeamless() && InHomeUtils.isFCPInProfile()) {
                if (lqResponse.hoaFlag === "Y") {
                    tempSCData.flowName = "prospect accord seamless move| vvp";
                }
                else {
                    tempSCData.flowName = "prospect accord seamless move";
                }
            }
            else if (InHomeUtils.isNotNull(isFCPflow) && isFCPflow && InHomeUtils.flowCheckforSeamless() && !InHomeUtils.isFCPInProfile()) {
                if (lqResponse.hoaFlag === "Y") {
                    tempSCData.flowName = "prospect accord seamless move| mix match| vvp";
                }
                else {
                    tempSCData.flowName = "prospect accord seamless move| mix match";
                }
            }
            else {
                if (lqResponse.hoaFlag === "Y") {
                    tempSCData.flowName = "prospect accord move| vvp";
                }
                else {
                    tempSCData.flowName = "prospect accord move";
                }

            }
            updateSCcustomEvent("cartAddServiceMoves", "ddAddToCartEvent", "detailPageName,pageName,contentChannel")
        }
        else {
            if (flowType === "SUPP") {
                if (InHomeUtils.isNotNull(isFCPflow) && isFCPflow) {
                    tempSCData.flowName = "prospect accord supp| mix match";
                }
                else {
                    if (lqResponse.hoaFlag === "Y") {
                        tempSCData.flowName = "prospect accord supp| vvp";
                    } else {
                        tempSCData.flowName = "prospect accord supp";
                    }
                }
                updateSCcustomEvent("cartAddServiceSupp", "ddAddToCartEvent", "");
            }
            else {
                if (InHomeUtils.isNotNull(isFCPflow) && isFCPflow) {
                    tempSCData.flowName = "prospect accord | mix match";
                }
                else {
                    if (lqResponse.hoaFlag === "Y") {
                        tempSCData.flowName = "prospect accord| vvp";
                    }
                    else {
                        tempSCData.flowName = "prospect accord ";
                    }

                }
                updateSCcustomEvent("cartAddService", "ddAddToCartEvent", "detailPageName,pageName");
            }
        }
    }
    catch (ex) {
        catchJSException('DTMTag', visitId, 'addToCartSCEvent', ex);
    }
}

export const cartAddEventEC = (cartResponse, bundleDetails, evnts, visitId) => {
    try {
        let pegaOffer = "pega";
        if ((bundleDetails) && (bundleDetails.offerName))
            pegaOffer = bundleDetails.offerName.replace("||","").toLowerCase();
        var dpName = "atom| nclick| renewal| " + pegaOffer + "| plan details| <offer type>";
        var spName = "nclick| renewal| " + pegaOffer + "| plan details";
        var contChan = "";
        var promoadded = "<offer type>| " + pegaOffer + "| <bundleid>";
        let srvcsOrdered = (InHomeUtils.isNotNull(cartResponse.orderDetail) && InHomeUtils.isNotNull(cartResponse.orderDetail.servicesOrdered)) ? cartResponse.orderDetail.servicesOrdered.replace("DATA", "fdata").replace("VIDEO", "ftv").replace("FIOS_VOICE", "fphone") : "";
        let srvcsVal = ""
        if (srvcsOrdered !== "") {
            let srvcs = srvcsOrdered.split(',');
            if (srvcs.length === 3) {
                srvcsVal = "triple - "
            }
            else if (srvcs.length === 2) {
                srvcsVal = "double - "
            }
            else {
                srvcsVal = "single - "
            }
            srvcsVal = srvcsVal + srvcsOrdered.replace(/,/g, "+");
        }

        var addToCartEvent = {
            eventInfo: { eventName: "ddAddToCartEvent", timeStamp: new Date(), processed: { adobeAnalytics: false } },
            cart: { productsSelected: srvcsVal },
            page: { pageName: spName, detailPageName: dpName, contentChannel: contChan },
            scEvents: evnts
        };

        if (bundleDetails) {
            let dtmoffername = bundleDetails.offerName.replace('||', '');
            let dtmoffertype = bundleDetails.offerType;

            if (promoadded.indexOf('<offer type>') > -1 && typeof bundleDetails.offerType !== 'undefined' && bundleDetails.offerType != null && bundleDetails.offerType != '')
                promoadded = promoadded.replace('<offer type>', bundleDetails.offerType);
            if (promoadded.indexOf('<bundleid>') > -1 && typeof bundleDetails.bundleType !== 'undefined' && bundleDetails.bundleType != null && bundleDetails.bundleType != '')
                promoadded = promoadded.replace('<bundleid>', bundleDetails.bundleType);
            if (promoadded.indexOf('<offer name>') > -1 && typeof bundleDetails.offerName !== 'undefined' && bundleDetails.offerName != null && bundleDetails.offerName != '') {
                var firstoffer = bundleDetails.offerName;
                firstoffer = firstoffer.replace('||', '');
                promoadded = promoadded.replace('<offer name>', firstoffer);
            }

            if (dpName.indexOf('<offer type>') > -1 && dtmoffertype)
                dpName = dpName.replace('<offer type>', dtmoffertype);
            if (dpName.indexOf('<offer name>') > -1 && dtmoffername) {
                dpName = dpName.replace('<offer name>', dtmoffername);
                spName = spName.replace('<offer name>', dtmoffername);
            }
        }

        addToCartEvent.page.pageName = spName;
        addToCartEvent.page.detailPageName = dpName;
        addToCartEvent.page.contentChannel = contChan;
        addToCartEvent.page.events = evnts;
        addToCartEvent.cart.totalRecurring = cartResponse.tierPricing.tierContent[0].totalMonthlyPrice.replace('$', '');
        addToCartEvent.cart.totalNonRecurring = cartResponse.tierPricing.tierContent[0].totalNrcPrice.replace('$', '');
        addToCartEvent.cart.changeAmount = "0.00";
        addToCartEvent.cart.productsSelected = srvcsVal;
        addToCartEvent.page.promoOfferDetails = promoadded;

        addToCartEvent.product = setDTMCartProductsRenewal(addToCartEvent, cartResponse, visitId);
        window.digitalData.product = addToCartEvent.product;
        window.digitalData = window.digitalData || {};
        window.digitalData.events = window.digitalData.events || [];
        window.digitalData.events.push(addToCartEvent);
        sendCustomEvent("ddAddToCartEvent");
    }
    catch (ex) {
        catchJSException('DTMTag', visitId, 'cartAddEventEC', ex);
    }
};

export const setDTMCartProductsRenewal = (addToCartEvent, cartResponse, visitId) => {
    try {
        addToCartEvent.product = [];
        let cartProducts = '';
        if (cartResponse != null)
            cartProducts = cartResponse.tierPricing.tierContent;

        if (cartProducts != null && cartProducts.length > 0 && cartProducts[0].sections != null && cartProducts[0].sections.section != null) {
            let bundleProd = new Object();
            if (cartResponse.orderDetail != null && cartResponse.orderDetail.bundle == true) {
                bundleProd.productNumber = cartResponse.orderDetail.bundleId;
            }

            cartProducts[0].sections.section.map((cartsections, index) => {
                if (cartsections != null && cartsections.subSections != null && cartsections.subSections.subSection != null) {
                    cartsections.subSections.subSection.map((cartsubsection, index) => {
                        if (cartsubsection != null) {
                            if (cartResponse.orderDetail != null && cartResponse.orderDetail.bundle == true && cartsubsection.sectionType == 'SVCCOMPONENT') {
                                bundleProd.productID = cartsubsection.title;
                                bundleProd.primaryCategoryandSub = cartsubsection.sectionType;
                                bundleProd.quantity = "1";
                                bundleProd.priceDiscount = "0";
                                bundleProd.priceRecurring = cartsubsection.sectionTotalprice;
                                bundleProd.priceBase = cartsubsection.sectionTotalprice;
                                bundleProd.type = cartsubsection.sectionType;
                                addToCartEvent.product.push(bundleProd);
                            }

                            if (cartsubsection.products != null) {
                                cartsubsection.products.map((value, index) => {
                                    if (value.prodName != null) {
                                        let prod = new Object();
                                        if (value.prodType == "FVPRIMARY") {
                                            prod.productID = value.prodName.replace(/[^A-Za-z ]+/g, '');
                                        }
                                        else {
                                            prod.productID = value.prodName;
                                        }
                                        prod.productNumber = value.prodId;
                                        prod.primaryCategoryandSub = value.prodType;
                                        prod.quantity = "1";
                                        prod.priceDiscount = "0";
                                        if (value.priceType == "NRC") {
                                            prod.priceNonRecurring = value.price;
                                        } else {
                                            prod.priceRecurring = value.price;
                                        }
                                        prod.priceBase = value.price;
                                        prod.type = value.prodType;
                                        prod.priceType = value.priceType;
                                        UpdateContractforRenewal(prod);
                                        addToCartEvent.product.push(prod);
                                    }
                                });
                            }

                            if (cartsubsection.promos != null) {
                                cartsubsection.promos.map((value, index) => {
                                    let prod = new Object();
                                    prod.productID = value.promoText;
                                    prod.productNumber = value.promoId;
                                    prod.primaryCategoryandSub = value.offerAttrValue;
                                    prod.quantity = "1";
                                    if (value.price != null)
                                        prod.priceDiscount = value.price;
                                    else
                                        prod.priceDiscount = "0"
                                    prod.priceRecurring = "0";
                                    prod.priceBase = "0";
                                    prod.type = value.offerAttr;
                                    addToCartEvent.product.push(prod);
                                });
                            }
                            if (cartsubsection.promotions != null) {
                                cartsubsection.promotions.map((value, index) => {
                                    if (value.OfferAttr && value.OfferAttr != "|NOTFORBACKEND|") {
                                        var prod = new Object();
                                        prod.productID = value.name;
                                        prod.productNumber = value.id;
                                        prod.primaryCategoryandSub = value.prodType;
                                        prod.quantity = "1";
                                        if (value.price != null)
                                            prod.priceDiscount = value.price;
                                        else
                                            prod.priceDiscount = "0"
                                        prod.priceRecurring = "0";
                                        prod.priceBase = "0";
                                        prod.type = value.OfferAttr;
                                        if (value.promotionId != null)
                                            prod.promoID = value.promotionId;
                                        if (value.offerId != null)
                                            prod.offerID = value.offerId;
                                        addToCartEvent.product.push(prod);
                                    }
                                });
                            }
                        }
                    });
                }
            });
        }
    }
    catch (ex) {
        catchJSException('DTMTag', visitId, 'setDTMCartProductsRenewal', ex);
    }

    return addToCartEvent.product;
}

const UpdateContractforRenewal = (prod) => {
    try {
        if (prod != null) {
            if (prod.productID != null && prod.productID == '2 Year commitment') {
                prod.productID = 'TwoYears agreement plan';
                prod.primaryCategoryandSub = 'NewAgreement';
            }
        }
    }
    catch (e) {
    }

}

const calcprdBasePrice = (product) => {
    let strprice = "0";
    if (InHomeUtils.isNull(product.originalPrice)) {
        if (InHomeUtils.isNotNull(product.displayPrice))
            strprice = product.displayPrice.replace("$", "")
    }
    else {
        strprice = InHomeUtils.isNull(product.originalPrice) ? product.originalPrice : "0";
    }
    return strprice;
}

export const scbuildButtonNxtLinkTrack = (tierdata, isdigitalAdapterAvail) => {
    try {
        let scinternetfinaldata = "Internet: plan -";
        let isinternetincart = false;
        let istvincart = false;
        let isfvcincart = false;
        let isstbincart = false;
        let sctvfinaldata = "TV: plan -";
        let scvoicefinaldata = "phone: plan - ";
        let isrecordingincart = false;
        let isbbuincart = false;
        let sccontractfinaldata = "contract :";
        let isdigitalAdapterincart = false;


        //Get first Core services 
        tierdata.sections.section[0].subSections.subSection[0].products.map(prdobj => {
            if (prdobj.prodType === 'FTTPD') {
                scinternetfinaldata += prdobj.prodName.toLowerCase();
                isinternetincart = true;
            }
            if (prdobj.prodType === 'BASIC') {
                sctvfinaldata += prdobj.prodName.toLowerCase();
                istvincart = true;
            }
            if (prdobj.prodType === 'FVPRIMARY') {
                scvoicefinaldata += prdobj.prodName.toLowerCase();
                isfvcincart = true;
            }
            if (prdobj.prodName.indexOf("agreement") > -1 || prdobj.prodName.indexOf("contract") > -1) {
                sccontractfinaldata += prdobj.prodName.indexOf("2 Year") > -1 ? "term" : "no term";
            }
        })


        tierdata.sections.section.map(secObj => {
            if (secObj.sectionName === "Equipment") {
                secObj.subSections.subSection.map(subSecObj => {
                    if (subSecObj.sectionType === "ROUTER") {

                        let tempval = subSecObj.products[0].prodName.indexOf("my own") > -1 ? " have own router" : "rent router";
                        if (isinternetincart) {
                            scinternetfinaldata = scinternetfinaldata + " |  " + tempval;
                        } else {
                            sctvfinaldata = sctvfinaldata + " |  " + tempval;
                        }
                    }
                    if (istvincart) {
                        if (subSecObj.sectionType === "SETUPBOX") {
                            isstbincart = true;
                            sctvfinaldata = sctvfinaldata + " |  tv equip - " + subSecObj.products[0].prodName.replace("HD Set-top box", "tv");
                        }
                        if (subSecObj.sectionType === "RECORDING") {
                            isrecordingincart = true;
                            sctvfinaldata = sctvfinaldata + " |  " + subSecObj.products[0].prodName.toLowerCase();
                        }
                        if (subSecObj.sectionType === "DIGITALADAPTOR") {
                            isdigitalAdapterincart = true;
                            sctvfinaldata = sctvfinaldata + " |  dig adapter";
                        }
                    }

                })
            }

            if (secObj.sectionName === "Service") {
                secObj.subSections.subSection.map(subSecObj => {
                    if (subSecObj.sectionType === "CHANNEL") {
                        sctvfinaldata = sctvfinaldata + " | " + "prem chnl -";
                        let chnldata = ""
                        subSecObj.products.map(prdObj => {
                            chnldata = (chnldata === "") ? (prdObj.prodTypeVal.toLowerCase()) : (chnldata + "+" + prdObj.prodTypeVal.toLowerCase());
                        })
                        sctvfinaldata = sctvfinaldata + chnldata;
                    }

                    if (subSecObj.sectionType === "LISTING") {
                        if (subSecObj.products[0].prodType === "FVNONPUB") {
                            scvoicefinaldata += "| exclude dir listing ";
                        }
                        else {
                            scvoicefinaldata += "| include dir listing";
                        }
                    }
                })
            }

            if (secObj.sectionName === "Onetimecharges") {
                secObj.subSections.subSection.map(subSecObj => {
                    if (subSecObj.sectionType === "BATTERYBACKUP") {
                        isbbuincart = true;
                        scvoicefinaldata += " |battery backup"
                    }
                    else if (subSecObj.sectionType === "ROUTERBUY") {
                        if (isinternetincart) {
                            scinternetfinaldata = scinternetfinaldata + " |  buy router";
                        } else {
                            sctvfinaldata = sctvfinaldata + " |  buy router";
                        }
                    }

                })

            }

        })

        if (isfvcincart && !isbbuincart) {
            scvoicefinaldata += "| no battery backup";
        }

        if (istvincart && isstbincart && !isrecordingincart) {
            sctvfinaldata += "| no recording";
        }
        if (istvincart && isdigitalAdapterAvail && !isdigitalAdapterincart) {
            sctvfinaldata += "|no dig adapter"
        }
        if (istvincart && isdigitalAdapterAvail && isdigitalAdapterincart && !isstbincart) {
            sctvfinaldata += "|tv equip - none tv"
        }

        if (isinternetincart) {
            updateSCTags(scinternetfinaldata)
        }
        if (istvincart) {
            updateSCTags(sctvfinaldata);
        }
        if (isfvcincart) {
            updateSCTags(scvoicefinaldata);
        }
        updateSCTags(sccontractfinaldata);

    }
    catch (error) {
        console.log(error);
    }
}

export const scClickEventProduct = (product, prodType, isChecked=false) => {
    let taggingServiceType = prodType;
    let details;
    if (prodType === Service.tv) {
        let buildProductState = store && store.getState && store.getState().buildProduct;
        taggingServiceType = buildProductState?.tv?.spanishTV ? "SPANISHTV" : "LIVETV";

    }
    try {
        let val = "select - "
        if(isChecked){
            val = "remove - "
        }
        if (prodType === Service.internet) {
           // val = "select - " + product.name.toLowerCase();
           val = val + InHomeUtils.getInternetDetailName(product?.id)
        }
        else if (prodType === Service.tv) {
           let name =  product.name?.replace("4.0","") 
            //val = "tv plan - " + name //preferred tv hd + "tv" // changing tv-plan to select 
           val = val + name 

            if (product.prodTypeValue === "Fios_Five") {
                val = val + "yftv";
            }
            else if (product.prodTypeValue === "ULTIMATETESTDRIVE" && !isChecked) {
                val = "add - " + name;
            }
        }
        else if (prodType === Service.voice) {
            val = val + product.name?.replace("4.0","") 
        }
        else if (prodType === Service.router) {
            val = val + product.name.toLowerCase();

        }
        else if(prodType === Service.splOffer) {
            val = val + product.OfferText
        }
        else if (prodType === Service.techSure) {
            if(!isChecked){
                val = "add - "
           }
            val = val + product.name.toLowerCase();
        }
        else if (prodType === Service.vRoom) {
            val = "tv equip - " + product.unitCount;
        }
        else if (prodType === Service.recording) {
            val = val + product.name
        }
        else if (prodType === Service.channel) {
            let dispPrdName = product.name;

            if (dispPrdName.indexOf("STARZ") > -1)
                dispPrdName = "starz";
            if(!isChecked){
                 val = "add - "
            }
            val = val + dispPrdName;
        }
        else if(prodType == Service.intrnlChnl){
            if(!isChecked){
                val = "add - "
           }
            val = val + product.name
        }
        else if(prodType == Service.techSure){
            if(!isChecked){
                val = "add - "
           }
            val = val + product.name
        }
        else if (prodType === Service.customTV) {
            val = "custom tv plan -" + product.name.replace(/&amp;/g, "&");
        }
        else if (prodType === Service.listing) {
            if(!isChecked){
                val = InHomeUtils.isNotNull(product) && InHomeUtils.isNotNull(product.name) && product.name.indexOf("Do not") > -1 ? "select - do not list my number" : "select -  list my number";}
            else{
                val = InHomeUtils.isNotNull(product) && InHomeUtils.isNotNull(product.name) && product.name.indexOf("Do not") > -1 ? "remove - do not list my number" : "remove -  list my number"; }
             }
        else if (prodType === Service.battery) {
            if(!isChecked){
                val = InHomeUtils.isNotNull(product) && InHomeUtils.isNotNull(product.keyword) && product.keyword.indexOf("ZRATED_DEC") > -1 ? "select - no, i don't want a powerreserve" : "select -  yes, i'd like a powerreserve";
            }
            else{
                val = InHomeUtils.isNotNull(product) && InHomeUtils.isNotNull(product.keyword) && product.keyword.indexOf("ZRATED_DEC") > -1 ? "remove - no, i don't want a powerreserve" : "remove -  yes, i'd like a powerreserve";
            }
        }
        else if (prodType === Service.streamServ) {
            val = "streaming -" + product.name;
        }
        else if (prodType === Service.streamDev) {
            val = "stream device -" + product.name;
        }
        else if (prodType === Service.streamDevCount) {
            let dispDeviceNum = product.name;
            if (InHomeUtils.isNotNull(product) && InHomeUtils.isNotNull(dispDeviceNum) && dispDeviceNum.indexOf("") > -1) {
                dispDeviceNum = dispDeviceNum.split("")[0];
            }
            val = "stream device num -" + dispDeviceNum;
        }
        else if (prodType === Service.flashOffer) {
            val = product.OfferText.replace('$100 ', '');
        }
        else if(Service.ceAppsBundle === prodType) {
            val = val + product.name;
        }else if(Service.intlPlans === prodType) {
            val = val + product.name;
        } else if(Service.winBack === prodType) {
            if(product.name === `I'd like a new phone number.`){
                val = val +  "no, i would like a new number" 
            }
            else {
                val =  val = val + "yes, check my number" 
            }
        }else if(Service.batteryshipment === prodType) {
            val = val + product.name;
        } 
        else if (prodType === Service.splOffer) {
            let offerName = InHomeUtils.isNotNull(product) ? product.OfferText : "";
            val = offerName;
        }else {
            val = val + product.name;
        }

        if(prodType === Service.internet){
            details= InHomeUtils.getInternetDetailName(product?.id)
        }
        else{
            details=InHomeUtils.isNotNull(ServiceTaggingDetail[taggingServiceType]) && InHomeUtils.isNotEmpty(ServiceTaggingDetail[taggingServiceType])? ServiceTaggingDetail[taggingServiceType]: ''
        }

       
        updateSCTags(val, '',details );
    }
    catch (error) {
        console.log(error)
    }
}

export const comparePlanOverlayView = (pegaState) => {
    var dpName = "atom| nclick| renewal| plan details| ";
    let bundleDetails = pegaState.bundles.length > 0 ? pegaState.bundles[0] : null;
    let dtmoffername = bundleDetails.offerName.replace('||', '');
    let dtmoffertype = bundleDetails.offerType;
    if (bundleDetails.offerType && bundleDetails.offerType != null && bundleDetails.offerType != '') {
        dpName = dpName.concat(bundleDetails.offerType, "| compare plan");
    }
    var spName = "nclick| renewal| plan details| compare plan";
    var contChan = "";
    var evnts = "event5";
    if (dtmoffername !== 'undefined' && dtmoffername != null && dtmoffername != '') {
        spName = "nclick| renewal| " + dtmoffername + "| plan details| compare plan";
    }
    if (dtmoffername !== 'undefined' && dtmoffername != '' && dtmoffertype !== 'undefined' && dtmoffertype != '') {
        dpName = "atom| nclick| renewal| " + dtmoffername + "| plan details| " + dtmoffertype + "| compare plan";
    }
    let tempSCData = {
        pageName: spName,
        detailPageName: dpName,
        contentChannel: contChan,
        events: evnts
    };
    customEventUpdate(tempSCData, "ddPageViewUpdateEvent");
}

export const channelLineupOverlayView = (pegaState) => {
    var dpName = "atom| nclick| renewal| plan details| ";
    let bundleDetails = pegaState.bundles.length > 0 ? pegaState.bundles[0] : null;
    let dtmoffername = bundleDetails.offerName.replace('||', '');
    let dtmoffertype = bundleDetails.offerType;
    if (bundleDetails && bundleDetails != null && bundleDetails != '') {
        if (bundleDetails.offerType && bundleDetails.offerType != null && bundleDetails.offerType != '') {
            dpName = dpName.concat(bundleDetails.offerType, "| channel lineup");
        }
    }
    var spName = "nclick| renewal| plan details| channel lineup";
    var contChan = "";
    var evnts = "event5";
    if (dtmoffername !== 'undefined' && dtmoffername != null && dtmoffername != '') {
        spName = "nclick| renewal| " + dtmoffername + "| plan details| channel lineup";
    }
    if (dtmoffername !== 'undefined' && dtmoffername != '' && dtmoffertype !== 'undefined' && dtmoffertype != '') {
        dpName = "atom| nclick| renewal| " + dtmoffername + "| plan details| " + dtmoffertype + "| channel lineup";
    }

    let tempSCData = {
        pageName: spName,
        detailPageName: dpName,
        contentChannel: contChan,
        events: evnts
    };
    customEventUpdate(tempSCData, "ddPageViewUpdateEvent");
}

export const whatToExpectOnNextBillOverlayView = (pegaState) => {
    var spName = "nclick| renewal| order confirmation| what to expect on next bill";
    var dpName = "atom| nclick| renewal| order confirmation| what to expect on next bill";
    let bundleDetails = pegaState.bundles.length > 0 ? pegaState.bundles[0] : null;
    let dtmoffername = bundleDetails.offerName.replace('||', '');
    let dtmoffertype = bundleDetails.offerType;
    var contChan = "";
    var evnts = "event5";
    if (dtmoffername !== 'undefined' && dtmoffername != null && dtmoffername != '') {
        spName = "nclick| renewal| " + dtmoffername + "| order confirmation| what to expect on next bill";
        dpName = "atom| nclick| renewal| " + dtmoffername + "| order confirmation| what to expect on next bill";
    }
    let tempSCData = {
        pageName: spName,
        detailPageName: dpName,
        contentChannel: contChan,
        events: evnts
    };
    customEventUpdate(tempSCData, "ddPageViewUpdateEvent");
}

export const termsOfServiceOverlayView = (pegaState) => {
    var spName = "nclick| renewal| checkout| terms of service";
    var dpName = "atom| nclick| renewal| checkout| terms of service";
    let bundleDetails = pegaState.bundles.length > 0 ? pegaState.bundles[0] : null;
    let dtmoffername = bundleDetails.offerName.replace('||', '');
    let dtmoffertype = bundleDetails.offerType;
    var contChan = "";
    var evnts = "event5";
    if (dtmoffername !== 'undefined' && dtmoffername != null && dtmoffername != '') {
        spName = "nclick| renewal| " + dtmoffername + "| checkout| terms of service";
        dpName = "atom| nclick| renewal| " + dtmoffername + "| checkout| terms of service";
    }
    let tempSCData = {
        pageName: spName,
        detailPageName: dpName,
        contentChannel: contChan,
        events: evnts
    };
    customEventUpdate(tempSCData, "ddPageViewUpdateEvent");
}

export const estimatedChargesOverlayView = (pegaState) => {
    var spName = "nclick| renewal| checkout| estimated charges";
    var dpName = "atom| nclick| renewal| checkout| estimated charges";
    let bundleDetails = pegaState.bundles.length > 0 ? pegaState.bundles[0] : null;
    let dtmoffername = bundleDetails.offerName.replace('||', '');
    let dtmoffertype = bundleDetails.offerType;
    var contChan = "";
    var evnts = "event5";
    window.digitalData.product = "";
    if (dtmoffername !== 'undefined' && dtmoffername != null && dtmoffername != '') {
        spName = "nclick| renewal| " + dtmoffername + "| checkout| estimated charges";
        dpName = "atom| nclick| renewal| " + dtmoffername + "| checkout| estimated charges";
    }
    let tempSCData = {
        pageName: spName,
        detailPageName: dpName,
        contentChannel: contChan,
        events: evnts
    };
    customEventUpdate(tempSCData, "ddPageViewUpdateEvent");
}

export const learnMoreOverlayView = (pegaState) => {
    var dpName = "";
    var offerName = "";
    let bundleDetails = pegaState.bundles.length > 0 ? pegaState.bundles[0] : null;
    let dtmoffername = bundleDetails.offerName.replace('||', '');
    let dtmoffertype = bundleDetails.offerType;
    if (bundleDetails && bundleDetails != null && bundleDetails != '') {
        if (InHomeUtils.isNotNull(bundleDetails.specialOffer) && InHomeUtils.isNotNull(bundleDetails.specialOffer[0].name)) {
            if ((bundleDetails.specialOffer[0].name.indexOf('Amazon Prime') > -1)
                && (bundleDetails.specialOffer[0].name
                    .indexOf('Amazon Echo') > -1)) {
                dpName = "atom| nclick| renewal| " + dtmoffername + "| plan details| offer| learn more| amazon prime-echo";
                offerName = "learn more: amazon prime-echo";
            } else if (bundleDetails.specialOffer[0].name
                .indexOf('Amazon Prime') > -1) {
                dpName = "atom| nclick| renewal| " + dtmoffername + "| plan details| offer| learn more| amazon prime";
                offerName = "learn more: amazon prime";
            } else if (bundleDetails.specialOffer[0].name.indexOf('Amazon Echo') > -1) {
                dpName = "atom| nclick| renewal| " + dtmoffername + "| plan details| offer| learn more| amazon echo";
                offerName = "learn more: amazon echo";
            } else if (bundleDetails.specialOffer[0].name.indexOf('Samsung') > -1) {
                dpName = "atom| nclick| renewal| " + dtmoffername + "| plan details| offer| learn more| google nest";
                offerName = "learn more: google nest";
            } else if (bundleDetails.specialOffer[0].name.indexOf('Netflix') > -1) {
                dpName = "atom| nclick| renewal| " + dtmoffername + "| plan details| offer| learn more| netflix";
                offerName = "learn more: netflix";
            } else if (bundleDetails.specialOffer[0].name.indexOf('Stadia') > -1) {
                offerName = "details - upgrade - fios gig and stadia";
            } else {
                dpName = "atom| nclick| renewal| " + dtmoffername + "| plan details| offer| learn more| visa card";
                offerName = "learn more: visa card";
            }
        }
    }
    updateSCTags(offerName);
    var spName = "nclick| renewal| plan details| offer| learn more";
    var contChan = "";
    var evnts = "event5";
    if (dtmoffername !== 'undefined' && dtmoffername != null && dtmoffername != '') {
        spName = "nclick| renewal| " + dtmoffername + "| plan details| offer| learn more";

    }
    window.digitalData.product = "";
    let tempSCData = {
        pageName: spName,
        detailPageName: dpName,
        contentChannel: contChan,
        events: evnts
    };
    customEventUpdate(tempSCData, "ddPageViewUpdateEvent");
}




